import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface DomainAcceptRefundSellerRequest {
  orderItemIDs: number[];
}

export interface DomainAcceptReturnProSellerRequest {
  orderItemIDs: number[];
}

export interface DomainAddressInfoProSeller {
  /** 상세주소 */
  additionalAddress: string;
  /** 주소 */
  address: string;
  name: string;
  /** 우편번호 */
  zoneCode: string;
}

export interface DomainAdminItem {
  adminID?: number;
  memo?: string;
  permissions?: DomainAdminItemPermission[];
  roles?: string[];
  username?: string;
}

export interface DomainAdminItemPermission {
  description?: string;
  id?: number;
  name?: string;
}

export interface DomainBackofficeAcceptDisputeOrderRequest {
  /** @example [1] */
  orderItemIDs: number[];
  /** @example "BUYER" */
  reasonType: DomainOrderDisputeReasonType;
}

export interface DomainBackofficeAdminSetPermission {
  permissionIDs?: number[];
}

export interface DomainBackofficeCreateAdminRequest {
  memo: string;
  password: string;
  permissionIDs: number[];
  username: string;
}

export interface DomainBackofficeCreatePresignedUrlRequest {
  category?: string;
  contentType?: string;
}

export type DomainBackofficeDeleteAdminRequest = object;

export interface DomainBackofficeDeleteMarketItemRequest {
  userID?: number;
}

export interface DomainBackofficeDisputeOrderRequest {
  /** @example [1] */
  orderItemIDs: number[];
}

export interface DomainBackofficeDownloadSettlementsXlsxRequest {
  settlementIDs?: number[];
}

export interface DomainBackofficeGetMarketItemEditableResponse {
  editable: boolean;
  message?: string;
}

export interface DomainBackofficeGetMarketItemResponse {
  /**
   * 해당 중고 물품에 북마크 한 수
   * @example 1
   */
  bookmarkCount: number;
  /**
   * 중고 옷 브랜드명
   * @example "SOUTH FACE"
   */
  brandName: string;
  /**
   * 중고 아이템 구매자 유저 ID
   * @example 22612346
   */
  buyerID?: number;
  categoryID?: number;
  /** @example 2626123 */
  clothesID?: number;
  /**
   * 중고 아이템 국가 코드
   * @example "KR"
   */
  countryCode: string;
  /**
   * 중고 아이템 생성일
   * @example 1668080178342
   */
  createDate: number;
  /**
   * TODO: 아래필드는 삭제 예정 (4.4.0) <-- 진짜 삭제하는지 확인
   * @example "KRW"
   */
  currency: string;
  /**
   * 중고 아이템 설명
   * @example "사실 2년 입었어유"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 2000
   */
  discountPrice: number;
  /**
   * 중고 아이템 할인율
   * @example 30
   */
  discountRate: number;
  /** @example "MARKET-ITEM_FABRIC_COTTON" */
  fabric: string;
  /**
   * 조건부 무료 배송 조건
   * @example 1000
   */
  freeOnAmount: number;
  genderWear?: string;
  images?: string[];
  /** @example false */
  isBookmarked: boolean;
  /**
   * 중고 아이템 삭제 여부
   * @example false
   */
  isDeleted: boolean;
  /**
   * 프로셀러 여부
   * @example true
   */
  isProSeller: boolean;
  /** 비슷한 상품 여부 */
  isSimilar?: boolean;
  /**
   * 지점명 노출 여부
   * @example true
   */
  isVisible: boolean;
  /**
   * 중고 아이템 검색 키워드
   * @example ["흰색","티셔츠","남성"]
   */
  keywords: string[];
  /**
   * 공급사명(지점명)
   * @example "공급사 없음"
   */
  logixName: string;
  logixPrice: DomainLogixPrice;
  logixType: DomainLogixType;
  /** @example 1246561453 */
  marketItemID: number;
  /**
   * 중고 아이템 수정일
   * @example 1668080178342
   */
  modifyDate: number;
  /**
   * 중고 아이템 가격
   * @example 3000
   */
  price: number;
  /**
   * 중고 아이템의 상태 (깨끗함, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  /**
   * 중고 옷 사이즈
   * @example "FREE"
   */
  size: string;
  /** 중고 아이템 판매 상태 */
  status: DomainMarketItemStatus;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  thumbnailURL: string;
  /**
   * 중고 아이템 제목
   * @example "새것 같은 노스페이스 패딩 팔아유"
   */
  title: string;
  userEmail?: string;
  /**
   * 중고 아이템 판매자 유저 ID
   * @example 22612346
   */
  userID: number;
  userNickname?: string;
  userPhone?: string;
  /** 와우 할인가 */
  wowDiscountAmount?: number;
}

export interface DomainBackofficeGetUserResponse {
  clothesCount?: number;
  dailylookCount?: number;
  deleteDate?: number;
  ideaCount?: number;
  marketItemCount?: number;
  recent3MAccessCount?: number;
  recent9MAccessCount?: number;
  recentAccessDate?: number;
  signUpDate?: number;
  user?: DomainUserItem;
}

export interface DomainBackofficeListActiveInfosResponse {
  activeUserInfos?: DomainBackofficeListActiveUserInfo[];
}

export interface DomainBackofficeListActiveUserInfo {
  avg_dau?: number;
  avg_mau?: number;
  avg_wau?: number;
  date?: string;
  dau?: number;
  mau?: number;
  wau?: number;
}

export interface DomainBackofficeListAdminsResponse {
  adminItems?: DomainAdminItem[];
  hasNext?: boolean;
}

export interface DomainBackofficeListContactsResponse {
  contacts?: DomainContactItem[];
  hasNext?: boolean;
}

export interface DomainBackofficeListMarketItemsResponse {
  hasNext?: boolean;
  marketItems?: DomainBackofficeMarketItem[];
}

export interface DomainBackofficeListOrdersResponse {
  /** @example true */
  hasNext: boolean;
  orders?: DomainOrderItemForBackofficeDTO[];
}

export interface DomainBackofficeListReportsResponse {
  hasNext?: boolean;
  reports?: DomainReportItem[];
}

export interface DomainBackofficeListRetentionRateMonthlyResponse {
  userRetentionRateMonthlyArr: DomainBackofficeUserRetentionRateMonthly[];
}

export interface DomainBackofficeListRetentionRateWeeklyResponse {
  userRetentionRateWeeklyArr: DomainBackofficeUserRetentionRateWeekly[];
}

export interface DomainBackofficeListSettlementsResponse {
  hasNext?: boolean;
  settlementItems?: DomainSettlementItem[];
}

export interface DomainBackofficeListTxsResponse {
  /** @example true */
  hasNext: boolean;
  txs?: DomainOrderItemListDto[];
}

export interface DomainBackofficeListUsersResponse {
  hasNext?: boolean;
  userItems?: DomainUserItem[];
}

export interface DomainBackofficeMarketItem {
  /**
   * 해당 중고 물품에 북마크 한 수
   * @example 1
   */
  bookmarkCount: number;
  /**
   * 중고 옷 브랜드명
   * @example "SOUTH FACE"
   */
  brandName: string;
  /**
   * 중고 아이템 구매자 유저 ID
   * @example 22612346
   */
  buyerID?: number;
  categoryID?: number;
  /** @example 2626123 */
  clothesID?: number;
  /**
   * 중고 아이템 국가 코드
   * @example "KR"
   */
  countryCode: string;
  /**
   * 중고 아이템 생성일
   * @example 1668080178342
   */
  createDate: number;
  /**
   * TODO: 아래필드는 삭제 예정 (4.4.0) <-- 진짜 삭제하는지 확인
   * @example "KRW"
   */
  currency: string;
  /**
   * 중고 아이템 설명
   * @example "사실 2년 입었어유"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 2000
   */
  discountPrice: number;
  /**
   * 중고 아이템 할인율
   * @example 30
   */
  discountRate: number;
  /** @example "MARKET-ITEM_FABRIC_COTTON" */
  fabric: string;
  /**
   * 조건부 무료 배송 조건
   * @example 1000
   */
  freeOnAmount: number;
  genderWear?: string;
  images?: string[];
  /** @example false */
  isBookmarked: boolean;
  /**
   * 중고 아이템 삭제 여부
   * @example false
   */
  isDeleted: boolean;
  /**
   * 프로셀러 여부
   * @example true
   */
  isProSeller: boolean;
  /** 비슷한 상품 여부 */
  isSimilar?: boolean;
  /**
   * 지점명 노출 여부
   * @example true
   */
  isVisible: boolean;
  /**
   * 중고 아이템 검색 키워드
   * @example ["흰색","티셔츠","남성"]
   */
  keywords: string[];
  /**
   * 공급사명(지점명)
   * @example "공급사 없음"
   */
  logixName: string;
  logixPrice: DomainLogixPrice;
  logixType: DomainLogixType;
  /** @example 1246561453 */
  marketItemID: number;
  /**
   * 중고 아이템 수정일
   * @example 1668080178342
   */
  modifyDate: number;
  /**
   * 중고 아이템 가격
   * @example 3000
   */
  price: number;
  /**
   * 중고 아이템의 상태 (깨끗함, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  /**
   * 중고 옷 사이즈
   * @example "FREE"
   */
  size: string;
  /** 중고 아이템 판매 상태 */
  status: DomainMarketItemStatus;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  thumbnailURL: string;
  /**
   * 중고 아이템 제목
   * @example "새것 같은 노스페이스 패딩 팔아유"
   */
  title: string;
  userEmail?: string;
  /**
   * 중고 아이템 판매자 유저 ID
   * @example 22612346
   */
  userID: number;
  userNickname?: string;
  userPhone?: string;
  /** 와우 할인가 */
  wowDiscountAmount?: number;
}

export interface DomainBackofficePatchContactRequest {
  answerStatus?: 'CONTACT_ANSWER_RESPONSE-COMPLETE' | 'CONTACT_ANSWER_RESPONSE-DENIED';
}

export interface DomainBackofficePatchSettlementsRequest {
  settlementIDs?: number[];
  status?:
    | 'SETTLEMENT_STATUS_UNAUDITED'
    | 'SETTLEMENT_STATUS_SCHEDULED'
    | 'SETTLEMENT_STATUS_COMPLETED'
    | 'SETTLEMENT_STATUS_HOLD';
}

export type DomainBackofficeRefreshTokenRequest = object;

export interface DomainBackofficeRejectDisputeOrderRequest {
  /** @example [1] */
  orderItemIDs: number[];
}

export interface DomainBackofficeRetentionRate {
  count: number;
  fromDate: string;
  rate: number;
  toDate: string;
  /** monthly, weekly */
  type: string;
}

export interface DomainBackofficeSignInRequest {
  password: string;
  username: string;
}

export interface DomainBackofficeSignInResponse {
  access_token?: string;
}

export interface DomainBackofficeUserRetentionRateMonthly {
  RetentionRate0M: DomainBackofficeRetentionRate;
  RetentionRate1M: DomainBackofficeRetentionRate;
  RetentionRate2M: DomainBackofficeRetentionRate;
  RetentionRate3M: DomainBackofficeRetentionRate;
}

export interface DomainBackofficeUserRetentionRateWeekly {
  RetentionRate0W: DomainBackofficeRetentionRate;
  RetentionRate1W: DomainBackofficeRetentionRate;
  RetentionRate2W: DomainBackofficeRetentionRate;
  RetentionRate3W: DomainBackofficeRetentionRate;
}

export interface DomainBanUserRequest {
  bannedUserID: number;
}

export interface DomainBankAccountVerificationRequest {
  /** 판매자 예금주명 */
  accountHolder: string;
  /** 판매자 계좌번호 */
  accountNumber: string;
  bankCode: string;
  bankName: string;
}

export interface DomainBottomCategory {
  id?: number;
  name?: string;
}

export type DomainBrandDivision = 'GLOBAL' | 'CUSTOM' | 'TOTAL';

export interface DomainBrandDto {
  /** @example 1 */
  brandID: number;
  /** @example "THE NORTH FACE" */
  brandName: string;
  /** @example "더 노스 페이스" */
  brandNameKr: string;
  logoUrl?: string;
}

export interface DomainBrandFilter {
  filterBrandItems: DomainFilterBrandItem[];
}

export interface DomainBrandTagDto {
  brandCategoryImage: string;
  brandSectionTitle: string;
  brandTagID: number;
  isBrandCategoryVisible: boolean;
  name: string;
  officialBrandCount: number;
  officialBrands: DomainOfficialBrandDto[];
}

export interface DomainCancelDetail {
  orderItemID?: number;
  reason?: DomainCancelOrderReason;
  reasonDetail?: string;
  withoutMarketItemStatus?: boolean;
}

export interface DomainCancelOrderByBuyerRequest {
  orderItems: DomainCancelOrderItem[];
}

export interface DomainCancelOrderBySellerRequest {
  orderItems: DomainCancelDetail[];
}

export interface DomainCancelOrderInfoByBuyerResponse {
  /** 취소 금액 */
  cancelAmount?: number;
  /** 환불 수단 */
  payMethod?: DomainPayMethod;
  /** 환불 차감 쿠폰 금액 */
  refundDeductionCouponAmount?: number;
  /** 환불 차감 배송비 */
  refundDeductionLogixAmount?: number;
  /** 환불 차감 반품 배송비 */
  refundDeductionLogixReturnAmount?: number;
  /** 환불 차감 금액 */
  refundDeductionTotalAmount?: number;
  /** 환불 금액 */
  returnAmount?: number;
  /** 반품 가능 여부 */
  returnable?: boolean;
}

export interface DomainCancelOrderItem {
  orderItemID: number;
  reason: DomainCancelOrderReason;
  reasonDetail?: string;
}

export type DomainCancelOrderReason =
  | 'deleteItem'
  | 'failPayment'
  | 'sellerNoAnswer'
  | 'cancelSellerReason1'
  | 'adminRefundApproval'
  | 'cancelReasonRefund'
  | 'cancelReasonAlreadyProcessed'
  | 'externalRequest'
  | 'cancelManagerReason'
  | 'cancelExtraReason'
  | 'cancelSellerReason2'
  | 'paymentTimeout';

export interface DomainCancelablePurchaseOrderItemsResponse {
  orderItems?: DomainOrderItemDetailDto[];
}

export interface DomainCategoryFilter {
  filterTopCategories: DomainFilterTopCategory[];
}

export interface DomainCategoryGroup {
  group: string;
  ids: number[];
}

export interface DomainClaimPurchaseRequest {
  /**
   * 구매를 거절할 중고 아이템과 연결된 중고 아이템 ID
   * @example 162581
   */
  marketItemID: number;
}

export interface DomainCloseMarketItemRequest {
  /**
   * 판매 종료 시 판매자가 구매자를 선택하는 경우 구매자 ID
   * @example 25123561
   */
  buyerID?: number;
  /**
   * 판매 종료할 중고 아이템 ID
   * @example 123415
   */
  marketItemID: number;
}

export interface DomainClothesProperty {
  /** @example "aiProperty" */
  aiProperty: string;
  /** @example 21 */
  categoryID: number;
  /** @example [2,3] */
  colorIDs: number[];
  cropBox: DomainCropBoxProperty;
  /** @example "iVBORw0KGgoAAAA" */
  croppedImage?: string;
  /** @example "uuid.png" */
  filename: string;
  /** @example "iVBORw0KGgoAAAA" */
  maskImage: string;
  /** @example [2,3] */
  materialIDs?: number[];
  /** @example [2,3] */
  patternIDs?: number[];
  season: DomainSeasonIndex;
}

export interface DomainColorFilter {
  filterColorItems: DomainFilterColorItem[];
}

export interface DomainConfirmOrderBySellerRequest {
  orderItemIDs: number[];
}

export interface DomainConfirmPurchaseByBuyerRequest {
  orderItemIDs: number[];
}

export interface DomainConfirmablePurchaseOrderItemsResponse {
  orderItems?: DomainOrderItemDetailDto[];
}

export interface DomainContactItem {
  answerStatus?:
    | 'CONTACT_ANSWER_AWAITING-RESPONSE'
    | 'CONTACT_ANSWER_RESPONSE-COMPLETE'
    | 'CONTACT_ANSWER_RESPONSE-DENIED';
  content?: string;
  createDt?: number;
  deviceInfo?: DomainContactItemDeviceInfo;
  id?: number;
  lastAppVersion?: string;
  locale?: DomainContactItemLocale;
  permission?: DomainContactItemPermission;
  title?: string;
  userEmail?: string;
  userID?: number;
}

export interface DomainContactItemDeviceInfo {
  appVersion?: string;
  device?: string;
  freeStorage?: string;
  osVersion?: string;
  timeozne?: string;
}

export interface DomainContactItemLocale {
  countryCode?: string;
  isRTL?: boolean;
  languageCode?: string;
  languageTag?: string;
}

export interface DomainContactItemPermission {
  camera?: string;
  location?: string;
  photo?: string;
}

export interface DomainCopyClothesRequest {
  /** 옷장 IDs */
  closetID: number;
  /** 라이브러리 옷 IDs */
  libraryClothesIDs: number[];
}

export interface DomainCountCartsResponse {
  count: number;
}

export interface DomainCountMarketItemBrandsResponse {
  marketItemBrandCount?: number;
}

export interface DomainCountNotificationsResponse {
  /**
   * 알림 개수
   * @example 1
   */
  notificationCount: number;
}

export interface DomainCountOfficialBrandsResponse {
  officialBrandCount?: number;
}

export interface DomainCountRafflesResponse {
  count: number;
}

export interface DomainCountSendbirdUnreadMessageResponse {
  /**
   * 안읽은 메세지 개수
   * @example 7
   */
  count: number;
}

export interface DomainCountUserMarketItemResponse {
  /**
   * 유저가 구매자로 참여한 중고 아이템 수
   * @example 0
   */
  buyMarketItemCount: number;
  /**
   * 유저가 판매자로 참여한 중고 아이템 수
   * @example 0
   */
  sellMarketItemCount: number;
}

export interface DomainCountUserMarketItemReviewResponse {
  /**
   * 유저가 받은 구매 리뷰 수
   * @example 0
   */
  buyReviewCount: number;
  /**
   * 유저가 받은 판매 리뷰 수
   * @example 0
   */
  sellReviewCount: number;
}

export interface DomainCountWeeklyMarketItemResponse {
  count?: number;
}

export interface DomainCountryResponse {
  /**
   * 국가코드 (ISO 3166)
   * @example "KR"
   */
  countryCode: string;
  /**
   * 위도 (좌표계 : EPSG:4326)
   * @example 35.907757
   */
  latitude: number;
  /**
   * 경도 (좌표계 : EPSG:4326)
   * @example 127.76692
   */
  longitude: number;
}

export type DomainCouponCalcType = 'COUPON_CALC_TYPE_RATE' | 'COUPON_CALC_TYPE_AMOUNT';

export interface DomainCouponConditionDTO {
  conditionType?: DomainCouponConditionType;
  proSellerID?: number;
  userCreateDateEnd?: string;
  userCreateDateStart?: string;
}

export type DomainCouponConditionType = 'USER_CREATE_DATE' | 'PRO_SELLER_ID';

export interface DomainCouponItem {
  allowDuplicateUsage: boolean;
  /** 정률, 정액 */
  couponCalcType: DomainCouponCalcType;
  couponCode: string;
  couponConditions?: DomainCouponConditionDTO[];
  couponContentImages?: string[];
  couponDescription: string;
  couponID: number;
  couponImage: string;
  couponIssueButtonImage: string;
  couponName: string;
  couponStatus?: DomainCouponStatus;
  couponUsageMax?: number;
  discountAmount: number;
  /** 정률인 경우 */
  discountAmountMax: number;
  eventEndDate: string;
  eventStartDate: string;
  /** 유효 기간 (24시간) */
  expirationDuration: number;
  isActivate: boolean;
  issuedCouponCount?: number;
  /** 정률인 경우 */
  txAmountMin: number;
  usedCouponCount?: number;
}

export type DomainCouponStatus = 'COUPON_STATUS_IDLE' | 'COUPON_STATUS_IN_PROGRESS' | 'COUPON_STATUS_END';

export interface DomainCreateCartRequest {
  marketItemID?: number;
}

export interface DomainCreateClothes {
  brand?: number;
  categoryID: number;
  closetIDs?: number[];
  /** 배경 제거된 이미지 */
  clothesImagePath?: string;
  clothesImageURL?: string;
  /** frontend에서 colors 유지 */
  colors: number[];
  isFall?: boolean;
  isSpring?: boolean;
  isSummer?: boolean;
  isWinter?: boolean;
  /** frontend에서 materials 유지 */
  materials?: number[];
  memo?: string;
  /** frontend에서 occasions 유지 // nc_map_closet_tag 저장, occasion 관련 정보 */
  occasions?: number[];
  /** 배경 제거 안 된 이미지 */
  originalClothesImagePath?: string;
  originalClothesImageURL?: string;
  /** frontend에서 patterns 유지 */
  patterns?: number[];
  price?: number;
  properties?: string;
  purchaseDate?: string;
  shopLink?: string;
  size?: string;
  /** nc_core_closet_keyword 저장 */
  tags?: string[];
}

export interface DomainCreateClothesV2Request {
  clothesList?: DomainCreateClothes[];
}

export interface DomainCreateCouponRequest {
  allowDuplicateUsage: boolean;
  /** 정률, 정액 */
  couponCalcType: DomainCouponCalcType;
  couponDescription: string;
  couponImage: string;
  couponName: string;
  discountAmount: number;
  /** 정률인 경우 */
  discountAmountMax: number;
  /** 유효 기간 (24시간) */
  expirationDuration: number;
  /** 정률인 경우 */
  txAmountMin: number;
}

export interface DomainCreateDailylookRequest {
  /**
   * 비율(1:1, 3:4)
   * @example "1/1"
   */
  aspectRatio: string;
  /**
   * 캘린더 날짜
   * @example "20221012"
   */
  calendarDate: string;
  /**
   * 캘린더 날씨 최고 온도
   * @example 19
   */
  calendarTemperatureMax?: number;
  /**
   * 캘린더 날씨 최저 온도
   * @example 10
   */
  calendarTemperatureMin?: number;
  /**
   * 캘린더 날씨 코드
   * @example "WEATHER_SNOW"
   */
  calendarWeatherCode?: string;
  /** 데일리룩 컨텐츠 리스트 */
  contents: DomainDailylookContentRequest[];
  /**
   * 설명
   * @example "이것은 데일리룩"
   */
  description?: string;
  /** 데일리룩 이미지 리스트 */
  images: DomainDailylookImageRequest[];
  /**
   * 비공개 여부
   * @example true
   */
  isPrivate: boolean;
}

export interface DomainCreateIdeaCommentRequest {
  /** 아이디어 댓글 */
  comment: string;
  /** 덧글을 단 아이디어의 작성자 */
  ideaUserID: number;
}

export interface DomainCreateIdeaLikeRequest {
  /** 좋아요를 누른 아이디어의 작성자 */
  ideaUserID: number;
}

export interface DomainCreateIdeaRequest {
  /**
   * 비율(1:1, 3:4)
   * @example "1/1"
   */
  aspectRatio: string;
  /**
   * 속성 코드 리스트
   * @example ["OUTFIT_SEASON_SUMMER"]
   */
  attributeCodes?: string[];
  /** 아이디어 컨텐츠 리스트 */
  contents: DomainIdeaContentRequest[];
  /**
   * 설명
   * @example "이것은 아이디어"
   */
  description?: string;
  /**
   * 태그 리스트
   * @example ["6월 여행"]
   */
  ideaTags?: string[];
  /** 아이디어 이미지 리스트 */
  images: DomainIdeaImageRequest[];
  /**
   * 비공개 여부
   * @example true
   */
  isPrivate: boolean;
  /**
   * 내 언어
   * @example "en"
   */
  language: string;
}

export interface DomainCreateMarketItemChatroomRequest {
  /**
   * 타겟유저 ID
   * @example 12383
   */
  targetUserID: number;
}

export interface DomainCreateMarketItemChatroomResponse {
  /**
   * 채팅방 ID (Sendbird Group Channel URL)
   * @example "sendbird_group_channel_175316761_dc76b0be7092ccc16cc4435a639697aaaa1e2b0f"
   */
  chatroomID: string;
  /**
   * 마켓 아이템 채팅방 ID (서버 관리 값)
   * @example 1823838
   */
  marketItemChatroomID: number;
}

export interface DomainCreateMarketItemImageRequest {
  /**
   * BASE64로 인코딩 된 이미지 바이너리
   * @example "BASE64"
   */
  base64: string;
  /**
   * 이미지 높이
   * @example 100
   */
  height: number;
  /**
   * 대표이미지 여부
   * @example true
   */
  isMain: boolean;
  /**
   * 이미지 순서
   * @example 1
   */
  order: number;
  /**
   * 이미지 폭
   * @example 100
   */
  width: number;
}

export interface DomainCreateMarketItemRequest {
  /**
   * 중고 아이템 브랜드 이름
   * @example "zara"
   */
  brandName?: string;
  /**
   * 중고 아이템 카테고리 ID
   * @example 56
   */
  categoryID: number;
  /**
   * 기존 옷에서 중고 아이템을 생성하는 경우 옷 ID
   * @example 16256124
   */
  clothesID?: number;
  /**
   * 중고 아이템 색상 ID 리스트
   * @example [2,6,7]
   */
  colorIDs?: number[];
  /**
   * 중고 아이템 내용
   * @example "직거래는 워싱턴에서 희망해요"
   */
  description: string;
  /**
   * 중고 아이템 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear:
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_GIRL';
  /** 중고 아이템 첨부 이미지 리스트 */
  images: DomainCreateMarketItemImageRequest[];
  logixPrice: DomainLogixPrice;
  logixType: 'MARKET-ITEM_LOGIX-TYPE_PREPAID-SHIPPING-FEE' | 'MARKET-ITEM_LOGIX-TYPE_COLLECT-ON-DELIVERY';
  /**
   * 중고 아이템 가격
   * @example 1000
   */
  price: number;
  /**
   * 중고 아이템 깨끗함 상태(깨끗, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality?:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  /**
   * 중고 아이템 사이즈
   * @example "XXL"
   */
  size?: string;
  /**
   * 중고 아이템 사이즈 ID
   * @example 1
   */
  sizeID?: number;
  /**
   * 중고 아이템 사이즈 지역
   * @example "kr"
   */
  sizeRegion?: string;
  /**
   * 중고 아이템 제목
   * @example "신품급 버버리 코트 팔아유"
   */
  title: string;
}

export interface DomainCreateMarketItemReviewRequest {
  /**
   * 리뷰 내용
   * @example "매너도 좋고 친절하세요 가방을 샀는데 패딩을 덤으로 주시네요 ㅜㅜ"
   */
  comment: string;
  /**
   * 평점 5점 만점
   * @example 5
   */
  rating: number;
  /**
   * 리뷰를 받는 유저 ID
   * @example 626723
   */
  revieweeID: number;
}

export interface DomainCreateMarketItemReviewResponse {
  /**
   * 정상 생성된 리뷰의 ID (PK)
   * @example 1
   */
  reviewID: number;
}

export interface DomainCreateMarketItemV2Request {
  /**
   * 중고 아이템 브랜드 이름
   * @example "zara"
   */
  brandName?: string;
  /**
   * 중고 아이템 카테고리 ID
   * @example 56
   */
  categoryID: number;
  /**
   * 기존 옷에서 중고 아이템을 생성하는 경우 옷 ID
   * @example 16256124
   */
  clothesID?: number;
  /**
   * 중고 아이템 색상 ID 리스트
   * @example [2,6,7]
   */
  colorIDs?: number[];
  /**
   * 중고 아이템 내용
   * @example "직거래는 워싱턴에서 희망해요"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 1000
   */
  discountPrice?: number;
  fabrics?: string[];
  /**
   * 중고 아이템 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear:
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_GIRL'
    | 'MARKET-ITEM_GENDERWEAR_UNISEX';
  /** 중고 아이템 첨부 이미지 리스트 */
  images: DomainMarketItemImageRequest[];
  itemOrigin?: string;
  keywords?: string[];
  logixID?: number;
  logixPrice: DomainLogixPrice;
  logixType: 'MARKET-ITEM_LOGIX-TYPE_PREPAID-SHIPPING-FEE' | 'MARKET-ITEM_LOGIX-TYPE_COLLECT-ON-DELIVERY';
  /** @example 1 */
  materialID?: number;
  neck: string;
  /** @example 1 */
  patternID?: number;
  /**
   * 중고 아이템 가격
   * @example 1000
   */
  price: number;
  /**
   * 중고 아이템 깨끗함 상태(깨끗, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality?:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  raglan?: DomainMarketItemRaglanType[];
  shoulderPad?: DomainMarketItemShoulderPadType[];
  /**
   * 중고 아이템 사이즈
   * @example "XXL"
   */
  size?: string;
  /**
   * 중고 아이템 사이즈 ID
   * @example 1
   */
  sizeID?: number;
  /**
   * 중고 아이템 사이즈 지역
   * @example "kr"
   */
  sizeRegion?: string;
  sleeveLength: string;
  /**
   * 중고 아이템 상태
   * @example "MARKET-ITEM_STATUS_FOR-SALE"
   */
  status?: DomainMarketItemStatus;
  /**
   * 중고 아이템 제목
   * @example "신품급 버버리 코트 팔아유"
   */
  title: string;
  waistBanding?: DomainMarketItemWaistBandingType[];
}

export interface DomainCreateOrderRequest {
  couponID?: number;
  isCartPayment?: boolean;
  logix?: DomainOrderBuyerLogix;
  marketItemIDs: number[];
  payMethod?: DomainPayMethod;
}

export interface DomainCreateOrderResponse {
  amount: number;
  buyerID: number;
  couponAmount?: number;
  couponID?: number;
  couponType?: string;
  marketItemTitle: string;
  merchantUID: string;
  sellerID: number;
  specialPrice: boolean;
}

export interface DomainCreatePresignedUrlRequest {
  category?: string;
  contentType?: string;
}

export interface DomainCreatePresignedUrlResponse {
  getUrl?: string;
  path?: string;
  putUrl?: string;
}

export interface DomainCreateProSellerLogixForLookoAIRequest {
  /** CS 담당 연락처 */
  afterServicePhoneNumber: string;
  /** 택배사 */
  courierCompany: string;
  /** 무료 배송 조건(배송료가 무료가 되는 주문금액) */
  freeOnAmount: number;
  /** 공급사명(지점명) 노출 여부 */
  isVisible: boolean;
  /** 지역 별 배송비 사용 여부 */
  logixFeeByArea: boolean;
  /** 공급사명(지점명) */
  logixName: string;
  /** 배송비 */
  logixPrice: DomainLogixPrice;
  /** 배송 타입 */
  logixType: DomainLogixType;
  /** 최대 구매 수량 */
  purchaseQuantity: number;
  /** 수거 방법 */
  refundLogixType: DomainRefundLogixType;
  /** 반품 주소 */
  returnAddress: string;
  /** 반품 상세 주소 */
  returnAddressDetail: string;
  /** 반품 배송비 */
  returnFee: number;
  /** 반품 이름 */
  returnName: string;
  /** 반품 정책 */
  returnPolicy: string;
  /** 반품 우편 번호 */
  returnZipCode: string;
}

export interface DomainCreateProSellerLogixForLookoAIResponse {
  /** 공급사 아이디 */
  logixID: number;
}

export interface DomainCreateRaffleRequest {
  /** 내 닉네임 */
  nickname: string;
  /** 친구 닉네임 */
  targetNickname: string;
}

export interface DomainCreateReportRequest {
  /**
   * 신고 상세 사유
   * @example "이거 이거 완전 사기꾼이에요"
   */
  detail?: string;
  /**
   * 신고 사유 코드
   * @example "REPORT_REASON_SPAM"
   */
  reasonCode: 'REPORT_REASON_SPAM' | 'REPORT_REASON_NUDITY' | 'REPORT_REASON_HATE-SPEECH';
  /**
   * 신고 타입 코드
   * @example "REPORT_TYPE_USER"
   */
  reportType: 'REPORT_TYPE_USER' | 'REPORT_TYPE_COMMENT' | 'REPORT_TYPE_CLOTHES' | 'REPORT_TYPE_OUTFIT';
  /** 신고 당한 object 아이디 */
  reportedID: number;
  /** 신고 당한 유저 아이디 */
  reportedUserID: number;
}

export interface DomainCreateUserCouponRequest {
  couponCode?: string;
  couponID: number;
}

export interface DomainCreateWishlistRequest {
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 필터에 대한 설명
   * @example "1000~50000, ZARA, 남자, 옷파는야옹이, 파란색"
   */
  description?: string;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example ["MARKET-ITEM_GENDERWEAR_MEN","MARKET-ITEM_GENDERWEAR_WOMEN"]
   */
  genderWears?: DomainGenderWearType[];
  /** @example true */
  isNotification: boolean;
  /**
   * 빈 문자열은 안됨. 글자수 제한 없음
   * @example "스포츠 관심상품"
   */
  name: string;
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example 40000
   */
  priceMax?: number;
  /** @example 1000 */
  priceMin?: number;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  sellerIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 빈 문자열이 아닌 null 로 받음
   * @example "나이키 집업"
   */
  textSearch?: string;
}

export interface DomainCreateWishlistResponse {
  /** @example 1 */
  wishlistID: number;
}

export interface DomainCropBoxProperty {
  /** @example 960 */
  bottom: number;
  /** @example 0 */
  left: number;
  /** @example 1080 */
  right: number;
  /** @example 0 */
  top: number;
}

export interface DomainDailylookContentLocationRequest {
  /**
   * 각도
   * @example 0.289103
   */
  angle: number;
  /**
   * 뒤집기 여부
   * @example false
   */
  flip: boolean;
  /**
   * 위치 X
   * @example 0.375433
   */
  positionX: number;
  /**
   * 위치 Y
   * @example 0.380556
   */
  positionY: number;
  /**
   * 위치 Z
   * @example 1
   */
  positionZ: number;
  /**
   * 크기
   * @example 0.785851
   */
  scale: number;
}

export interface DomainDailylookContentLocationResponse {
  /**
   * 각도
   * @example 0.289103
   */
  angle: number;
  /**
   * 뒤집기 여부
   * @example false
   */
  flip: boolean;
  /**
   * 위치 X
   * @example 0.375433
   */
  positionX: number;
  /**
   * 위치 Y
   * @example 0.380556
   */
  positionY: number;
  /**
   * 위치 Z
   * @example 1
   */
  positionZ: number;
  /**
   * 크기
   * @example 0.785851
   */
  scale: number;
}

export interface DomainDailylookContentRequest {
  /**
   * 컨텐츠 아이디
   * @example 153
   */
  contentID: number;
  /**
   * 컨텐츠 타입
   * @example "OUTFIT_CONTENT_CLOTHES"
   */
  contentType: 'OUTFIT_CONTENT_CLOTHES' | 'OUTFIT_CONTENT_STICKER';
  /** 컨텐츠 위치 */
  location: DomainDailylookContentLocationRequest;
}

export interface DomainDailylookContentResponse {
  /**
   * 브랜드 이름
   * @example "zara, 없을 경우 : ''"
   */
  brandName: string;
  /**
   * 컨텐츠 아이디
   * @example 153
   */
  contentID: number;
  /**
   * 컨텐츠 타입
   * @example "OUTFIT_CONTENT_CLOTHES"
   */
  contentType: 'OUTFIT_CONTENT_CLOTHES' | 'OUTFIT_CONTENT_STICKER';
  /**
   * 데일리룩 컨텐츠 아이디
   * @example 12
   */
  dailylookContentID: number;
  /**
   * 컨텐츠 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/images/166807971683094699736_calendars.webp"
   */
  imageURL: string;
  /**
   * 컨텐츠 삭제 여부
   * @example false
   */
  isDeleted: boolean;
  /** 컨텐츠 위치 */
  location: DomainDailylookContentLocationResponse;
  /**
   * 구매 링크
   * @example "www.hkja.com"
   */
  shopLink?: string;
  /**
   * 썸네일 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/images/90_1668079695308793827O_image.webp"
   */
  thumbnailURL: string;
}

export interface DomainDailylookImageRequest {
  /**
   * 데일리룩 이미지 아이디 (수정 시 updateImages에만 필요)
   * @example 1424
   */
  dailylookImageID?: number;
  /**
   * 이미지 세로 길이
   * @example 512
   */
  height?: number;
  /**
   * 이미지 콘텐츠(Base64 string) 생성, 수정 시 insertImages에만 필요
   * @example "BASE64"
   */
  imageContent?: string;
  /**
   * 순서
   * @example 2
   */
  imageOrder: number;
  /**
   * 메인 이미지 여부
   * @example true
   */
  isMain: boolean;
  /**
   * 데일리룩 이미지 여부
   * @example false
   */
  isOutfit: boolean;
  /**
   * 이미지 가로 길이
   * @example 512
   */
  width?: number;
}

export interface DomainDailylookImageResponse {
  /**
   * 이미지 아이디
   * @example 2342
   */
  dailylookImageID: number;
  /** @example 1 */
  imageOrder: number;
  /**
   * 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/images/166807971683094699736_calendars.webp"
   */
  imageURL: string;
  /**
   * 메인 이미지 여부
   * @example true
   */
  isMain: boolean;
  /**
   * 데일리룩 이미지 여부
   * @example false
   */
  isOutfit: boolean;
  /**
   * 썸네일 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/images/90_1668079695308793827O_image.webp"
   */
  thumbnailURL: string;
}

export interface DomainDailylookResponse {
  /**
   * 비율(1:1, 3:4)
   * @example "1/1"
   */
  aspectRatio?: string;
  /**
   * 캘린더 날짜
   * @example "2022-11-11"
   */
  calendarDate: string;
  /**
   * 캘린더 날씨 최고 온도
   * @example 19
   */
  calendarTemperatureMax?: number;
  /**
   * 캘린더 날씨 최저 온도
   * @example 10
   */
  calendarTemperatureMin?: number;
  /**
   * 캘린더 날씨 코드
   * @example "WEATHER_RAIN"
   */
  calendarWeatherCode?: string;
  /** 데일리룩 컨텐츠 리스트 */
  contents: DomainDailylookContentResponse[];
  /**
   * 생성 날짜
   * @example 1668080178342
   */
  createDate: number;
  /**
   * 데일리룩 아이디
   * @example 1
   */
  dailylookID: number;
  /**
   * 설명
   * @example "행복한 여행"
   */
  description?: string;
  /** 이미지 리스트 */
  images: DomainDailylookImageResponse[];
  /**
   * 공개 여부
   * @example false
   */
  isPrivate: boolean;
  /** 유저 정보 */
  user: DomainDailylookUserResponse;
}

export interface DomainDailylookUserResponse {
  /**
   * 팔로잉 여부
   * @example true
   */
  isFollowing: boolean;
  /**
   * 닉네임
   * @example "hkja1"
   */
  nickname: string;
  /**
   * 프로필 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  profileImageURL: string;
  /**
   * 유저 아이디
   * @example 620687
   */
  userID: number;
}

export interface DomainDeleteCartRequest {
  marketItemIDs?: number[];
}

export interface DomainDeleteClothesRequest {
  clothesIDs: number[];
}

export interface DomainDeleteMarketItemChatroomsRequest {
  /**
   * 삭제하고자 하는 채팅방 ID 리스트
   * @example ["[sendbird-1238asd"," sendbird-fj934fj1]"]
   */
  chatroomIDs?: string[];
  /**
   * 중고 ID와 연관된 채팅방 모두 삭제
   * @example 96923
   */
  marketItemID?: number;
}

export interface DomainDeleteMarketItemImageRequest {
  /**
   * 중고 아이템 수정 시 삭제할 이미지 ID
   * @example 125161
   */
  imageID: number;
}

export interface DomainDiscountPriceFilter {
  discountPriceMax: number;
  discountPriceMin: number;
}

export interface DomainDispatchOrderBySellerRequest {
  orderItemLogixs: DomainOrderItemLogix[];
}

export interface DomainDisplay {
  /** '2column' | '3column' | 'horizontal' */
  layoutType: '2column' | '3column' | 'horizontal';
  /** @example "닉네임" */
  nickname?: string;
  /** @example "섹션 제목" */
  sectionTitle: string;
  /**
   * 유저 섹션 그리기 위한 유저 ID
   * @example 1
   */
  userID?: number;
}

export interface DomainDisplayRequest {
  /** '2column' | '3column' | 'horizontal' */
  layoutType: '2column' | '3column' | 'horizontal';
  /** @example "닉네임" */
  nickname?: string;
  /** @example "섹션 제목" */
  sectionTitle: string;
  /**
   * 유저 섹션 그리기 위한 유저 ID
   * @example 1
   */
  userID?: number;
}

export interface DomainDuplicateCheckWishlistRequest {
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example ["MARKET-ITEM_GENDERWEAR_MEN","MARKET-ITEM_GENDERWEAR_WOMEN"]
   */
  genderWears?: DomainGenderWearType[];
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example 40000
   */
  priceMax?: number;
  /** @example 1000 */
  priceMin?: number;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  sellerIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 빈 문자열이 아닌 null 로 받음
   * @example "나이키 집업"
   */
  textSearch?: string;
}

export interface DomainDuplicateCheckWishlistResponse {
  /** @example true */
  isDuplicate: boolean;
}

export interface DomainExtendConfirmPurchaseByBuyerRequest {
  orderItemIDs: number[];
}

export interface DomainFilterBottomCategory {
  count: number;
  id: number;
  name: string;
}

export interface DomainFilterBrandItem {
  count: number;
  logoUrl: string;
  nameEn: string;
  nameKr: string;
  officialBrandID: number;
}

export interface DomainFilterColorItem {
  count: number;
  hexCode: string;
  id: number;
  name: string;
}

export interface DomainFilterGenderWearItem {
  count: number;
  name: string;
  sid: string;
}

export interface DomainFilterMiddleCategory {
  count: number;
  filterBottomCategories: DomainFilterBottomCategory[];
  name: string;
  sid: string;
}

export interface DomainFilterTopCategory {
  count: number;
  filterMiddleCategories: DomainFilterMiddleCategory[];
  id: number;
  name: string;
}

export interface DomainGenderWearFilter {
  filterGenderWearItems: DomainFilterGenderWearItem[];
}

export type DomainGenderWearType =
  | 'MARKET-ITEM_GENDERWEAR_WOMEN'
  | 'MARKET-ITEM_GENDERWEAR_MEN'
  | 'MARKET-ITEM_GENDERWEAR_GIRL'
  | 'MARKET-ITEM_GENDERWEAR_BOY'
  | 'MARKET-ITEM_GENDERWEAR_UNISEX'
  | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX';

export interface DomainGetBankAccountInfoResponse {
  /** 판매자 예금주명 */
  accountHolder: string;
  /** 판매자 계좌번호 */
  accountNumber: string;
  bankName: string;
}

export interface DomainGetBrandTagResponse {
  brandTag?: DomainBrandTagDto;
}

export interface DomainGetClothesUtilizationResponse {
  /** 옷 통계 오픈 여부 */
  isClothesUtilizationOpen: boolean;
  /** 일정에 등록된 옷 개수(중복 제거) */
  outfitClothesCount: number;
  /**
   * 옷 착용률
   * @example 8
   */
  ratio: number;
  /** 전체 옷 개수 */
  totalClothesCount: number;
}

export interface DomainGetCouponResponse {
  coupon: DomainCouponItem;
}

export interface DomainGetDailylookResponse {
  dailylook?: DomainDailylookResponse;
}

export interface DomainGetIdeaResponse {
  idea: DomainIdeaResponse;
}

export interface DomainGetLibraryClothesCountResponse {
  count: number;
}

export interface DomainGetMarketItemEditableResponse {
  editable: boolean;
  message?: string;
}

export interface DomainGetMarketItemResponse {
  /**
   * 해당 중고 물품에 북마크 한 수
   * @example 1
   */
  bookmarkCount: number;
  /**
   * 중고 옷 브랜드명
   * @example "SOUTH FACE"
   */
  brandName: string;
  /**
   * 중고 아이템 구매자 유저 ID
   * @example 22612346
   */
  buyerID?: number;
  /** @example 52 */
  categoryID: number;
  /** @example 2626123 */
  clothesID?: number;
  /**
   * 중고 아이템의 색상 ID 리스트
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 중고 아이템 국가 코드
   * @example "KR"
   */
  countryCode: string;
  /**
   * 중고 아이템 생성일
   * @example 1668080178342
   */
  createDate: number;
  /**
   * TODO: 아래필드는 삭제 예정 (4.4.0) <-- 진짜 삭제하는지 확인
   * @example "KRW"
   */
  currency: string;
  /**
   * 중고 아이템 설명
   * @example "사실 2년 입었어유"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 2000
   */
  discountPrice: number;
  /**
   * 중고 아이템 할인율
   * @example 30
   */
  discountRate: number;
  /** @example "MARKET-ITEM_FABRIC_COTTON" */
  fabric: string;
  /**
   * 조건부 무료 배송 조건
   * @example 1000
   */
  freeOnAmount: number;
  /**
   * 중고 아이템 성별
   * @example "MARKET-ITEM_GENDERWEAR_MAN"
   */
  genderWear:
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_GIRL';
  /** 중고 아이템 이미지 리스트 */
  images: DomainMarketItemImageResponse[];
  /** @example false */
  isBookmarked: boolean;
  /**
   * 중고 아이템 삭제 여부
   * @example false
   */
  isDeleted: boolean;
  /** 마켓아이템 상세에서 해당 마켓아이템이 장바구니에 담겼는지 확인 */
  isOnCart?: boolean;
  /**
   * 프로셀러 여부
   * @example true
   */
  isProSeller: boolean;
  /** 비슷한 상품 여부 */
  isSimilar?: boolean;
  /**
   * 지점명 노출 여부
   * @example true
   */
  isVisible: boolean;
  /**
   * 중고 아이템 검색 키워드
   * @example ["흰색","티셔츠","남성"]
   */
  keywords: string[];
  /**
   * 공급사명(지점명)
   * @example "공급사 없음"
   */
  logixName: string;
  logixPrice: DomainLogixPrice;
  logixType: DomainLogixType;
  /** @example 1246561453 */
  marketItemID: number;
  /**
   * 중고 아이템 수정일
   * @example 1668080178342
   */
  modifyDate: number;
  /**
   * 로그인 한 유저가 작성한 리뷰가 있을 경우 해당 ReviewID
   * @example 1
   */
  myReviewID?: number;
  /**
   * 중고 아이템 가격
   * @example 3000
   */
  price: number;
  /**
   * 중고 아이템의 상태 (깨끗함, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  /**
   * 중고 옷 사이즈
   * @example "FREE"
   */
  size: string;
  /** @example 1 */
  sizeID?: number;
  /** @example "kr" */
  sizeRegion?: 'it' | ' kr' | 'us' | ' uk' | ' eu';
  /** 중고 아이템 판매 상태 */
  status: DomainMarketItemStatus;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  thumbnailURL: string;
  /**
   * 중고 아이템 제목
   * @example "새것 같은 노스페이스 패딩 팔아유"
   */
  title: string;
  /**
   * 거래 희망 지역 // TODO 4.4.0 삭제 예정
   * @example "MARKET-ITEM_TRADE-REGION_LOCAL,MARKET-ITEM_TRADE-REGION_GLOBAL"
   */
  tradeRegion: string;
  /**
   * 중고 아이템 판매자 유저 ID
   * @example 22612346
   */
  userID: number;
  /** 와우 할인가 */
  wowDiscountAmount?: number;
}

export interface DomainGetMarketItemReviewResponse {
  /**
   * 리뷰 내용
   * @example "1시간 늦게 나왔네요"
   */
  comment: string;
  /**
   * 리뷰 생성일시 timestamp
   * @example 1668080178342
   */
  createDate: number;
  /**
   * 리뷰를 하는 사람의 회원 탈퇴 여부
   * @example true
   */
  isReviewerDeleted: boolean;
  /**
   * 리뷰와 연결된 중고 ID
   * @example 125156
   */
  marketItemID: number;
  /**
   * 해당 리뷰에 로그인 한 유저가 답 리뷰를 남겼을 경우 해당 리뷰 ID (없는 경우 null)
   * @example 125125
   */
  myReviewID?: number;
  /**
   * 리뷰 평점
   * @example 0.5
   */
  rating: number;
  /**
   * 리뷰 ID (PK)
   * @example 24521
   */
  reviewID: number;
  /**
   * 리뷰 종류 (구매/판매)
   * @example "MARKET-ITEM_REVIEW-TYPE_SELLING"
   */
  reviewType: 'MARKET-ITEM_REVIEW-TYPE_SELLING' | 'MARKET-ITEM_REVIEW-TYPE_BUYING';
  /** 리뷰를 받는 사람 */
  reviewee: DomainReviewUserResponse;
  /** 리뷰를 하는 사람 */
  reviewer: DomainReviewUserResponse;
}

export interface DomainGetMonthlyDailylookStatisticsResponse {
  mostWornClothesID: number;
  purchasePriceSum: number;
  thumbnailURL: string;
  wornCount: number;
}

export interface DomainGetMyInformationResponse {
  accountHolder?: string;
  accountNumber?: string;
  /**
   * 배경 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  backgroundImageURL?: string;
  bankName?: string;
  /**
   * 자기 소개
   * @example "Hello!"
   */
  bio?: string;
  /**
   * 생년월일
   * @example "2023-01-01"
   */
  birth: string;
  /**
   * 클라이언트 설정
   * @example "{isFirst:false}"
   */
  clientConfig?: string;
  /**
   * 댓글 알림 수신 여부
   * @example true
   */
  commentNotificationAgreed: boolean;
  /**
   * 국가 코드
   * @example "KR"
   */
  countryCode: string;
  /**
   * 통화
   * @example "KRW"
   */
  currency: string;
  /**
   * 국가 전화번호
   * @example "+82"
   */
  dialingCode?: string;
  /**
   * 접속 정보(GOOGLE, KAKAO ...)
   * @example "GOOGLE"
   */
  division?: string;
  /**
   * 이메일
   * @example "example@gmail.com"
   */
  email?: string;
  /**
   * 환율
   * @example 1
   */
  exchangeRate: number;
  /**
   * 팔로우 알림 수신 여부
   * @example true
   */
  followNotificationAgreed: boolean;
  /**
   * 성별
   * @example "MALE"
   */
  gender: string;
  /**
   * 키
   * @example 180.1
   */
  height?: number;
  /**
   * 계정 밴 여부
   * @example false
   */
  isBanned: boolean;
  /**
   * 게스트 여부
   * @example false
   */
  isGuest: boolean;
  /**
   * 해당 유저가 파워셀러인지 여부
   * @example false
   */
  isProSeller: boolean;
  /**
   * 인증 여부 Deprecated 4.1.0
   * @example false
   */
  isVerified: boolean;
  /**
   * 언어 코드
   * @example "ko"
   */
  language: string;
  /**
   * 좋아요 알림 수신 여부
   * @example true
   */
  likeNotificationAgreed: boolean;
  /**
   * 링크
   * @example "https://www.link.com/chicken/"
   */
  link?: string;
  /**
   * 마켓 아이템 북마크 알림 수신 여부
   * @example true
   */
  marketItemBookmarkNotificationAgreed: boolean;
  /** @example true */
  marketItemChattingPushNotificationAgreed: boolean;
  /** @example true */
  marketItemDiscountPushNotificationAgreed: boolean;
  /**
   * 마켓 아이템 리뷰 알림 수신 여부
   * @example true
   */
  marketItemReviewNotificationAgreed: boolean;
  /**
   * 휴대폰 번호
   * @example "01012345678"
   */
  mobile?: string;
  /**
   * 유저 이름
   * @example "홍길동"
   */
  name?: string;
  /**
   * 닉네임
   * @example "hkja1"
   */
  nickname: string;
  /**
   * 계정 비공개 여부
   * @example false
   */
  outfitPrivacy: boolean;
  /** 선호 옷장 */
  prefClosets: DomainPrefClosets;
  proSellerInfo?: DomainProSellerInfo;
  /**
   * 프로필 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  profileImageURL?: string;
  /**
   * 코디 추천 온도감(-2: 더 따뜻하게 입을래요, -1: 조금 따뜻하게 입을래요, 0: 적당해요, 1: 조금 시원하게 입을래요, 2: 더 시원하게 입을래요)
   * @example 0
   */
  tempSenseLevel: number;
  /** @example true */
  transactionPushNotificationAgreed: boolean;
  /**
   * 업데이트 알림 수신 여부
   * @example true
   */
  updateNotificationAgreed: boolean;
  /**
   * 에이클로젯 업데이트 알림 동의 날짜
   * @example 100030
   */
  updateNotificationAgreedDate?: number;
  /**
   * 유저 아이디
   * @example 620687
   */
  userID: number;
  /**
   * 회원가입 시 division 에 따라 배정되는 유니크한 유저 이름
   * @example "safasdf"
   */
  username: string;
  /**
   * 몸무게
   * @example 70.1
   */
  weight?: number;
}

export interface DomainGetOfficialBrandResponse {
  officialBrand?: DomainOfficialBrandDto;
}

export interface DomainGetOrderByImpUIDResponse {
  isCartPayment?: boolean;
  success?: boolean;
  txID?: number;
}

export interface DomainGetOrderPolicyResponse {
  pgFeeRate: number;
}

export interface DomainGetOrderResponse {
  /** 수수료 */
  agentFee: number;
  /** 수수료 할인 금액 */
  agentFeeDiscount: number;
  /** 수수료 할인 타입 */
  agentFeeDiscountType: string;
  /** 상품 금액 */
  amount: number;
  /** 구매자 ID */
  buyerID: number;
  /** 구매자 닉네임, snapshot */
  buyerNickname: string;
  /** 최종 환불금액 내역 */
  cancelAmount?: number;
  /** 쿠폰 할인 금액 */
  couponDiscountAmount: number;
  /** 쿠폰 */
  couponItem?: DomainCouponItem;
  /** 거래생성일 */
  createDate: string;
  /** 거래생성 unix timestamp */
  createdAt: number;
  /** 주문 */
  details: DomainOrderItemDetailDto[];
  /** 정산 예정 금액 */
  expectedSettlementAmount: number;
  /** 주문 ID */
  id: number;
  /** 구매자 탈퇴 여부 */
  isDeleteBuyer: boolean;
  /** 판매자 탈퇴 여부 */
  isDeleteSeller: boolean;
  /** 프로셀러 여부 */
  isProSeller: boolean;
  /** 상세주소 */
  logixAdditionalAddress: string;
  /** 주소 */
  logixAddress: string;
  /** 배송 메모 */
  logixMemo: string;
  /** 수령인 이름 */
  logixName: string;
  /** 수령인 전화번호 */
  logixPhone: string;
  /** 배송비 (실제) */
  logixPrice: number;
  /** 지역별 배송비 타입 일반, 제주, 도서산간 */
  logixPriceType: DomainLogixPriceType;
  /** 배송비 유형 */
  logixType: DomainLogixType;
  /** 우편번호 */
  logixZoneCode: string;
  /** 결제 금액 */
  paidAmount: number;
  /** 결제 정보 */
  paidAt: number;
  /** 결제 요청 수단 */
  payMethod: DomainPayMethod;
  /** PG수수료 */
  pgCommissionFee: number;
  /** 환불 차감 쿠폰 금액 */
  refundDeductionCouponAmount?: number;
  /** 환불 차감 배송비 */
  refundDeductionLogixAmount?: number;
  /** 환불 차감 반품 배송비 */
  refundDeductionLogixReturnAmount?: number;
  /** 환불 차감 금액 */
  refundDeductionTotalAmount?: number;
  /** 환불 수단 */
  refundPayMethod?: DomainPayMethod;
  /** 환불 정책 */
  refundPolicy: string;
  /** 환불 금액 */
  returnAmount?: number;
  /** 반품 택배사 */
  returnCourierName: string;
  /** 반품 방법 */
  returnLogixType: DomainRefundLogixType;
  /** 반품 가능 여부 */
  returnable?: boolean;
  /** 판매자가 구매자 주소 확인 할 수 있는 여부 */
  sellerAddrIsShow: boolean;
  /** 판매자 ID */
  sellerID: number;
  /** 판매자 닉네임, snapshot */
  sellerNickname: string;
  /** 판매자 연락처 */
  sellerNumber: string;
}

export interface DomainGetOrderReturnItemResponse {
  /** 메모 */
  address?: string;
  /** 상세주소 */
  addressDetails?: string;
  /** 반품 배송비 */
  logixReturnPrice?: number;
  marketItemID?: number;
  marketItemPrice?: number;
  marketItemThumbnail?: string;
  marketItemTitle?: string;
  /** 수거해주세요, 직접 보낼게요 */
  method?: DomainRefundLogixType;
  /** 수거 정보의 사람 이름 */
  name?: string;
  /** 연락처 */
  phone?: string;
  photos?: string[];
  /** 메모 */
  proSellerAddress?: string;
  /** 상세주소 */
  proSellerAddressDetails?: string;
  /** 수거 정보의 사람 이름 */
  proSellerName?: string;
  /** 연락처 */
  proSellerPhone?: string;
  /** 우편번호 */
  proSellerZipCode?: string;
  reasonDetail?: string;
  reasonType?: DomainRefundReason;
  status?: DomainOrderStatus;
  /** 우편번호 */
  zipCode?: string;
}

export interface DomainGetPaymentInfoResponse {
  agentFee: number;
  agentFeeDiscount: number;
  agentFeeDiscountType: string;
  amount: number;
  couponDiscountAmount: number;
  /**
   * 조건부 무료 배송 조건
   * @example 1000
   */
  freeOnAmount: number;
  logixInfo: DomainLogixPrice;
  logixPrice: number;
  logixPriceType: DomainLogixPriceType;
  logixType: DomainLogixType;
  marketItemCount: number;
  marketItemPrice: number;
  proSellerLogixPrice: number;
  proSellerLogixType: DomainLogixType;
  proSellerLogixTypeFreeOnAmount: number;
}

export interface DomainGetProSellerLogixInfoForLookoAIResponse {
  /** CS 담당 연락처 */
  afterServicePhoneNumber: string;
  /** 택배사 */
  courierCompany: string;
  /** 무료 배송 조건(배송료가 무료가 되는 주문금액) */
  freeOnAmount: number;
  /** 공급사명 노출 여부 */
  isVisible: boolean;
  /** 지역 별 배송비 사용 여부 */
  logixFeeByArea: boolean;
  /** 배송정보 ID */
  logixID: number;
  /** 공급사명(지점명) */
  logixName: string;
  /** 배송비 */
  logixPrice: DomainLogixPrice;
  /** 배송 타입 */
  logixType: DomainLogixType;
  /** 프로 셀러 ID */
  proSellerID: number;
  /** 최대 구매 수량 */
  purchaseQuantity: number;
  /** 수거 방법 */
  refundLogixType: DomainRefundLogixType;
  /** 반품 주소 */
  returnAddress: string;
  /** 반품 상세 주소 */
  returnAddressDetail: string;
  /** 반품 배송비 */
  returnFee: number;
  /** 반품 이름 */
  returnName?: string;
  /** 반품 정책 */
  returnPolicy: string;
  /** 반품 우편 번호 */
  returnZipCode: string;
}

export interface DomainGetRecentShippingAddressResponse {
  additionalAddress: string;
  address: string;
  memo?: string;
  name: string;
  phone: string;
  roadAddress: string;
  zoneCode: string;
}

export interface DomainGetSendbirdTokenResponse {
  /**
   * Sendbird 유저토큰 (만료기한 X)
   * @example "b057f665-c2b7-4a19-9fe4-cebf5fbb5159"
   */
  accessToken: string;
  /**
   * 유저 ID
   * @example 183831
   */
  userID: number;
}

export interface DomainGetUserProfileResponse {
  /**
   * 배경 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  backgroundImageURL?: string;
  /**
   * 자기 소개
   * @example "Hello!"
   */
  bio?: string;
  /**
   * 국가
   * @example "KR"
   */
  countryCode: string;
  /**
   * 팔로워 수
   * @example 1
   */
  followerCount: number;
  /**
   * 팔로잉 수
   * @example 1
   */
  followingCount: number;
  /**
   * 로그인 한 유저가 해당 유저를 차단했는지 여부
   * @example false
   */
  isBanned: boolean;
  /**
   * 조회한 유저 기준 팔로우 여부
   * @example true
   */
  isFollowing: boolean;
  /**
   * 해당 유저가 판매/구매한 물품이 있었는지 여부
   * @example false
   */
  isMarketUser: boolean;
  /**
   * 해당 유저가 파워셀러인지 여부
   * @example false
   */
  isProSeller: boolean;
  /**
   * 좋아요 수
   * @example 1
   */
  likeCount: number;
  /**
   * 링크
   * @example "https://www.link.com/chicken/"
   */
  link?: string;
  /**
   * 판매/구매한 물품 수
   * @example 1
   */
  marketItemCount: number;
  /**
   * 닉네임
   * @example "hkja1"
   */
  nickname: string;
  /**
   * 코디 나만 보기 모드
   * @example false
   */
  outfitPrivacy: boolean;
  /** 해당 유저의 파워셀러 정보 */
  proSellerInfo?: DomainProSellerInfo;
  /**
   * 프로필 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  profileImageURL?: string;
  /**
   * 받은 리뷰 수
   * @example 1
   */
  reviewCount: number;
  /**
   * 받은 리뷰 평점
   * @example 4.5
   */
  reviewScore: number;
  /**
   * 유저 아이디
   * @example 620687
   */
  userID: number;
}

export interface DomainGetWishlistResponse {
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 필터에 대한 설명
   * @example "1000~50000, ZARA, 남자, 옷파는야옹이, 파란색"
   */
  description?: string;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example ["MARKET-ITEM_GENDERWEAR_MEN","MARKET-ITEM_GENDERWEAR_WOMEN"]
   */
  genderWears?: DomainGenderWearType[];
  /**
   * 알람 여부
   * @example true
   */
  isNotification: boolean;
  /**
   * 새로 생성된 아이템을 확인했는지 여부 (true: 확인함, false: 확인하지 않음)
   * @example true
   */
  isSeen: boolean;
  /**
   * 빈 문자열은 안됨. 글자수 제한 없음
   * @example "스포츠 관심상품"
   */
  name: string;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 null 로 반환함.
   * @example 40000
   */
  priceMax?: number;
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 null 로 반환함.
   * @example 1000
   */
  priceMin?: number;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  sellerIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example "나이키 집업"
   */
  textSearch?: string;
  /** @example 1 */
  userID: number;
  /** @example 1 */
  wishlistID: number;
}

export interface DomainGetWornClothesCountResponse {
  /** 옷 ID */
  clothesID: number;
  wornClothesCount: number;
}

export interface DomainGetWowDiscountResponse {
  isFirst: boolean;
  isOpened: boolean;
  marketItemID?: number;
  wowDiscountID?: number;
}

export interface DomainHighestCPWClothes {
  /**
   * 브랜드 이름
   * @example "1234"
   */
  brandName: string;
  /**
   * 옷 아이디
   * @example 1234
   */
  clothesID: number;
  /**
   * 착용 횟수 당 가격
   * @example 14234.25
   */
  cpw: number;
  /**
   * 썸네일 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/images/166807971815507578418_calendars.webp"
   */
  thumbnailURL: string;
}

export interface DomainIdeaCommentResponse {
  /**
   * 아이디어 댓글
   * @example "정말 좋은 아이디어에요~ 하하"
   */
  comment: string;
  createDate: number;
  /**
   * 댓글 아이디
   * @example 11
   */
  ideaCommentID: number;
  /**
   * 닉네임
   * @example "hkja1"
   */
  nickname: string;
  /** @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp" */
  profileImageURL?: string;
  /**
   * 유저 아이디
   * @example 620687
   */
  userID: number;
}

export interface DomainIdeaContentLocationRequest {
  /**
   * 각도
   * @example 0.289103
   */
  angle: number;
  /**
   * 뒤집기 여부
   * @example false
   */
  flip: boolean;
  /**
   * 위치 X
   * @example 0.375433
   */
  positionX: number;
  /**
   * 위치 Y
   * @example 0.380556
   */
  positionY: number;
  /**
   * 위치 Z
   * @example 1
   */
  positionZ: number;
  /**
   * 크기
   * @example 0.785851
   */
  scale: number;
}

export interface DomainIdeaContentLocationResponse {
  /**
   * 각도
   * @example 0.289103
   */
  angle: number;
  /**
   * 뒤집기 여부
   * @example false
   */
  flip: boolean;
  /**
   * 위치 X
   * @example 0.375433
   */
  positionX: number;
  /**
   * 위치 Y
   * @example 0.380556
   */
  positionY: number;
  /**
   * 위치 Z
   * @example 1
   */
  positionZ: number;
  /**
   * 크기
   * @example 0.785851
   */
  scale: number;
}

export interface DomainIdeaContentRequest {
  /**
   * 컨텐츠 아이디
   * @example 153
   */
  contentID: number;
  /**
   * 컨텐츠 타입
   * @example "OUTFIT_CONTENT_CLOTHES"
   */
  contentType: 'OUTFIT_CONTENT_CLOTHES' | 'OUTFIT_CONTENT_STICKER';
  /** 컨텐츠 위치 */
  location: DomainIdeaContentLocationRequest;
}

export interface DomainIdeaContentResponse {
  /** @example "zara, 없을 경우 : ''" */
  brandName: string;
  /**
   * 컨텐츠 아이디
   * @example 153
   */
  contentID: number;
  /**
   * 컨텐츠 타입
   * @example "OUTFIT_CONTENT_CLOTHES"
   */
  contentType: 'OUTFIT_CONTENT_CLOTHES' | 'OUTFIT_CONTENT_STICKER';
  /**
   * 아이디어 컨텐츠 아이디
   * @example 12
   */
  ideaContentID: number;
  /**
   * 컨텐츠 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/images/166807971683094699736_calendars.webp"
   */
  imageURL: string;
  /**
   * 컨텐츠 삭제 여부
   * @example false
   */
  isDeleted: boolean;
  /** 컨텐츠 위치 */
  location: DomainIdeaContentLocationResponse;
  /**
   * 구매 링크
   * @example "www.hkja.com"
   */
  shopLink?: string;
  /**
   * 썸네일 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/images/90_1668079695308793827O_image.webp"
   */
  thumbnailURL: string;
}

export interface DomainIdeaImageRequest {
  /**
   * 이미지 세로 길이
   * @example 512
   */
  height?: number;
  /**
   * 아이디어 이미지 아이디 (수정 시 updateImages에만 필요)
   * @example 1424
   */
  ideaImageID?: number;
  /**
   * 이미지 콘텐츠(Base64 string) 생성, 수정 시 insertImages에만 필요
   * @example "BASE64"
   */
  imageContent?: string;
  /**
   * 순서, v2 에서 필요
   * @example 2
   */
  imageOrder: number;
  /** 이미지 주소 */
  imageUrl?: string;
  /**
   * 메인 이미지 여부, v2 에서 필요
   * @example true
   */
  isMain: boolean;
  /**
   * 아이디어 이미지 여부, v2 에서 필요
   * @example false
   */
  isOutfit: boolean;
  /** 썸네일 주소 */
  thumbnailUrl?: string;
  /**
   * 이미지 가로 길이
   * @example 512
   */
  width?: number;
}

export interface DomainIdeaImageResponse {
  /**
   * 이미지 아이디
   * @example 2342
   */
  ideaImageID: number;
  /** @example 1 */
  imageOrder: number;
  /**
   * 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/images/166807971683094699736_calendars.webp"
   */
  imageURL: string;
  /**
   * 메인 이미지 여부
   * @example true
   */
  isMain: boolean;
  /**
   * 아이디어 이미지 여부
   * @example false
   */
  isOutfit: boolean;
  /**
   * 썸네일 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/images/90_1668079695308793827O_image.webp"
   */
  thumbnailURL: string;
}

export interface DomainIdeaLikeResponse {
  /** @example true */
  isFollowing: boolean;
  /**
   * 닉네임
   * @example "hkja1"
   */
  nickname: string;
  /**
   * 프로필 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  profileImageURL: string;
  /**
   * 유저 아이디
   * @example 620687
   */
  userID: number;
}

export interface DomainIdeaResponse {
  /**
   * 비율(1:1, 3:4)
   * @example "1/1"
   */
  aspectRatio?: string;
  /**
   * 속성 코드 리스트
   * @example ["OUTFIT_SEASON_SPRING"]
   */
  attributeCodes?: string[];
  /** 아이디어 댓글 */
  comment?: DomainIdeaCommentResponse;
  /**
   * 댓글 개수
   * @example 15
   */
  commentCount: number;
  /** 아이디어 컨텐츠 리스트 */
  contents: DomainIdeaContentResponse[];
  /**
   * 생성 날짜
   * @example 1668080178342
   */
  createDate: number;
  /**
   * 설명
   * @example "행복한 여행"
   */
  description?: string;
  /**
   * 아이디어 아이디
   * @example 1
   */
  ideaID: number;
  /**
   * 태그 리스트
   * @example ["6월 여행"," 여름 바캉스"]
   */
  ideaTags?: string[];
  /** 이미지 리스트 */
  images: DomainIdeaImageResponse[];
  /**
   * 북마크 여부
   * @example true
   */
  isBookmarked: boolean;
  /**
   * 좋아요 여부
   * @example true
   */
  isLiked: boolean;
  /**
   * 공개 여부
   * @example false
   */
  isPrivate: boolean;
  /**
   * 좋아요 개수
   * @example 16
   */
  likeCount: number;
  /** 유저 정보 */
  user: DomainIdeaUserResponse;
}

export interface DomainIdeaTagHistoryResponse {
  /**
   * 아이디어 개수
   * @example 20
   */
  ideaCount: number;
  /**
   * 아이디어 태그
   * @example "6월 여행"
   */
  ideaTag: string;
}

export interface DomainIdeaTrendingTagResponse {
  /**
   * 인기 태그가 달린 아이디어 수
   * @example 10
   */
  ideaCount: number;
  /**
   * 인기 태그
   * @example "6월 여행"
   */
  ideaTag: string;
  /**
   * 인기 태그가 달린 아이디어 썸네일
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/images/3_1668079738074262348V_image.webp"
   */
  thumbnailURL: string;
}

export interface DomainIdeaTrendingUserResponse {
  /**
   * 좋아요 개수
   * @example 14240
   */
  likeCount: number;
  /**
   * 썸네일 URL 리스트
   * @example ["https://d3ku6i8uhaesym.cloudfront.net/calendars/images/166807978167810276627_calendars.webp"]
   */
  thumbnailURLs: string[];
  /** 유저 정보 */
  user: DomainIdeaUserResponse;
}

export interface DomainIdeaUserResponse {
  /**
   * 팔로잉 여부
   * @example true
   */
  isFollowing: boolean;
  /**
   * 닉네임
   * @example "hkja1"
   */
  nickname: string;
  /**
   * 프로필 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  profileImageURL: string;
  /**
   * 유저 아이디
   * @example 620687
   */
  userID: number;
}

export interface DomainLabelingClothesResponse {
  aiProperty?: any;
  createDate?: string;
  fileName?: string;
  id?: number;
  imageURL?: string;
  serviceProperty?: DomainServiceProperty;
}

export interface DomainLeastWornClothes {
  /**
   * 브랜드 이름
   * @example "8"
   */
  brandName: string;
  /**
   * 옷 아이디
   * @example 1234
   */
  clothesID: number;
  /**
   * 마지막 입은 날짜
   * @example "20221008"
   */
  lastWornDate: string;
  /**
   * 썸네일 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/images/90_1668079695308793827O_image.webp"
   */
  thumbnailURL: string;
}

export interface DomainLibraryClothesResponse {
  /**
   * 브랜드 이름
   * @example "H&M"
   */
  brandName?: string;
  /**
   * 라이브러리 설명
   * @example "logo-print cotton T-shirt"
   */
  description?: string;
  /**
   * 라이브러리 옷 ID
   * @example 1728997
   */
  libraryClothesID: number;
  /**
   * 썸네일 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  thumbnailURL: string;
}

export interface DomainListApplicableCouponsResponse {
  coupons: DomainCouponItem[];
}

export interface DomainListAppliedCouponsResponse {
  coupons: DomainCouponItem[];
}

export interface DomainListBookmarkIdeasResponse {
  ideas?: DomainIdeaResponse[];
  /**
   * 조회 타임스탬프
   * @example 1622544000000
   */
  searchTimestamp: number;
}

export interface DomainListBrandsResponse {
  brands?: DomainBrandDto[];
  hasNext?: boolean;
}

export interface DomainListCartSimilarMarketItemsResponse {
  mainMarketItems: DomainMarketItemResponse[];
  otherMarketItems: DomainMarketItemResponse[];
}

export interface DomainListCartsResponse {
  sellers: DomainListCartsSellerDto[];
}

export interface DomainListCartsSellerDto {
  isProSeller: boolean;
  isVisible: boolean;
  logixName: string;
  logixPrice: DomainLogixPrice;
  logixType: DomainLogixType;
  logixTypeFreeOnAmount: number;
  logixTypePayOnQuantity: number;
  marketItems?: DomainListCartsSellerMarketItemDto[];
  nickname: string;
  purchaseQuantityLimit: number;
  thumbnailURL: string;
  userID: number;
}

export interface DomainListCartsSellerMarketItemDto {
  brand: string;
  isDelete: boolean;
  marketItemID: number;
  price: number;
  status: DomainMarketItemStatus;
  thumbnailURL: string;
  title: string;
}

export interface DomainListClothesDailylooksResponse {
  dailylooks?: DomainDailylookResponse[];
  /**
   * 조회 타임스탬프
   * @example 1622544000000
   */
  searchTimestamp: number;
}

export interface DomainListClothesIdeasResponse {
  /** 아이디어 리스트 */
  ideas?: DomainIdeaResponse[];
  /**
   * 조회 타임스탬프
   * @example 1622544000000
   */
  searchTimestamp: number;
}

export interface DomainListClothesSizesResponse {
  categoryGroups: DomainCategoryGroup[];
  sizes: DomainSize[];
  /** 사이즈 번역 (For Girls on Boys) */
  translations: DomainTranslation[];
}

export interface DomainListFilterMarketItemCountsResponse {
  brandFilter: DomainBrandFilter;
  categoryFilter: DomainCategoryFilter;
  colorFilter: DomainColorFilter;
  discountPriceFilter: DomainDiscountPriceFilter;
  genderWearFilter: DomainGenderWearFilter;
  totalItemCount: number;
}

export interface DomainListFollowingsMarketItemsResponse {
  /**
   * 다음 페이지가 있는지 여부
   * @example true
   */
  hasNext: boolean;
  marketItems?: DomainMarketItemResponse[];
}

export interface DomainListHighestCPWClothesResponse {
  /** 가장 높은 CPW 옷 리스트 */
  highestCPWClothesList?: DomainHighestCPWClothes[];
}

export interface DomainListIdeaCommentsResponse {
  /** 아이디어 댓글 리스트 */
  comments?: DomainIdeaCommentResponse[];
  /**
   * 조회 타임스탬프
   * @example 1622544000000
   */
  searchTimestamp: number;
}

export interface DomainListIdeaLikesResponse {
  likes?: DomainIdeaLikeResponse[];
  /**
   * 조회 타임스탬프
   * @example 1622544000000
   */
  searchTimestamp: number;
}

export interface DomainListIdeaTagHistoriesResponse {
  /** 최근 검색 태그 리스트 */
  ideaTagHistories?: DomainIdeaTagHistoryResponse[];
}

export interface DomainListIdeaTagsResponse {
  /**
   * 태그
   * @example ["6월 여행"," 여름 바캉스 아이디어"]
   */
  ideaTags?: string[];
}

export interface DomainListIdeaTrendingTagsResponse {
  /** 인기 태그 리스트 */
  ideaTrendingTags?: DomainIdeaTrendingTagResponse[];
}

export interface DomainListIdeaTrendingUsersResponse {
  /** 인기 유저 리스트 */
  ideaTrendingUsers?: DomainIdeaTrendingUserResponse[];
  /**
   * 조회 타임스탬프
   * @example 1622544000000
   */
  searchTimestamp: number;
}

export interface DomainListIdeasResponse {
  ideas?: DomainIdeaResponse[];
  /**
   * 조회 타임스탬프
   * @example 1622544000000
   */
  searchTimestamp: number;
}

export interface DomainListLabelingClothesResponse {
  clothesList?: DomainLabelingClothesResponse[];
  from?: string;
  to?: string;
}

export interface DomainListLeastWornClothesResponse {
  /** 가장 적게 입은 옷 리스트 */
  leastWornClothesList?: DomainLeastWornClothes[];
}

export interface DomainListLibraryClothesResponse {
  libraryClothesList?: DomainLibraryClothesResponse[];
}

export interface DomainListMarketItemBrandsResponse {
  hasNext?: boolean;
  marketItemBrandItems?: DomainMarketItemBrandItem[];
}

export interface DomainListMarketItemChatroomsResponse {
  chatrooms?: DomainMarketItemChatroomResponse[];
}

export interface DomainListMarketItemsResponse {
  /**
   * 다음 페이지가 있는지 여부
   * @example true
   */
  hasNext: boolean;
  marketItems?: DomainMarketItemResponse[];
}

export interface DomainListMetadataResponse {
  count: number;
  domains: string[];
  items: DomainMetadataResponse[];
  subDomains: string[];
}

export interface DomainListMostWornClothesResponse {
  /** 가장 많이 입은 옷 리스트 */
  mostWornClothesList?: DomainMostWornClothesResponse[];
}

export interface DomainListMyDailylooksResponse {
  /** 데일리룩 리스트 */
  dailylooks?: DomainDailylookResponse[];
  /**
   * 조회 타임스탬프
   * @example 1622544000000
   */
  searchTimestamp: number;
}

export interface DomainListMyIdeasResponse {
  /** 아이디어 리스트 */
  ideas?: DomainIdeaResponse[];
  /**
   * 조회 타임스탬프
   * @example 1622544000000
   */
  searchTimestamp: number;
}

export interface DomainListNewMarketItemWishlistDTO {
  /**
   * 새로 생성된 아이템을 확인했는지 여부 (true: 확인함, false: 확인하지 않음)
   * @example true
   */
  isSeen: boolean;
  /**
   * 새로 생성된 아이템의 ID
   * @example 1
   */
  marketItemID?: number;
  /**
   * 새로 생성된 아이템의 썸네일 URL
   * @example "https://acloset-static.s3.ap-northeast-2.amazonaws.com/..."
   */
  marketItemThumbnailURL: string;
  /**
   * 빈 문자열은 안됨. 글자수 제한 없음
   * @example "스포츠 관심상품"
   */
  name: string;
  /** @example 1 */
  wishlistID: number;
}

export interface DomainListNewMarketItemWishlistsResponse {
  /** @example true */
  hasNext: boolean;
  wishlists?: DomainListNewMarketItemWishlistDTO[];
}

export interface DomainListNotificationsResponse {
  notifications?: DomainNotificationResponse[];
}

export interface DomainListOfficialBrandFollowsResponse {
  brandFollows?: DomainOfficialBrandDto[];
}

export interface DomainListOfficialBrandTagsResponse {
  brandTags?: DomainBrandTagDto[];
}

export interface DomainListOfficialBrandsResponse {
  hasNext?: boolean;
  officialBrands?: DomainOfficialBrandDto[];
}

export interface DomainListOrdersForLookoAIResponse {
  orders?: DomainOrderDTO[];
}

export interface DomainListOrdersResponse {
  /** @example true */
  hasNext: boolean;
  txs?: DomainOrderItemListDto[];
}

export interface DomainListPermissionsItem {
  description?: string;
  name?: string;
  readID?: number;
  updateID?: number;
}

export interface DomainListPermissionsResponse {
  permissions?: DomainListPermissionsItem[];
}

export interface DomainListProSellerLogixInfoForLookoAIResponse {
  logixInfos?: DomainProSellerLogixDTO[];
}

export interface DomainListProSellerUsersResponse {
  proSellerUserItems?: DomainProSellerUserItem[];
}

export interface DomainListPromotionInfoHistoriesResponse {
  nextCursor: number;
  promotionInfoHistories: DomainPromotionInfoHistory[];
}

export interface DomainListPromotionInfosResponse {
  promotionInfos: DomainPromotionInfo[];
}

export interface DomainListPropertiesWithMiddleCategoryResponse {
  topCategories?: DomainTopCategory[];
}

export interface DomainListRecentlyViewedMarketItemsResponse {
  marketItems?: DomainMarketItemResponse[];
}

export interface DomainListRecentlyWornClothesResponse {
  /** 최근에 입은 옷 리스트 */
  recentlyWornClothesList?: DomainRecentlyWornClothesResponse[];
}

export interface DomainListRecommInfoHistoriesResponse {
  nextCursor: number;
  recommSectionInfoHistories: DomainRecommSectionInfoHistory[];
}

export interface DomainListRecommInfosResponse {
  sectionInfos: DomainSectionInfo[];
}

export interface DomainListSettlementsResponse {
  hasNext?: boolean;
  settlementItems?: DomainSettlementItem[];
}

export interface DomainListSimilarIdeasResponse {
  /** 비슷한 아이디어 리스트 */
  ideas?: DomainIdeaResponse[];
  /**
   * 조회 타임스탬프
   * @example 1622544000000
   */
  searchTimestamp: number;
}

export interface DomainListTrendingIdeasResponse {
  /** 인기 아이디어 리스트 */
  ideas?: DomainIdeaResponse[];
}

export interface DomainListUserBookmarkMarketItemsResponse {
  marketItems?: DomainMarketItemResponse[];
}

export interface DomainListUserCouponsRequest {
  /** MarketItemID 결제 창에서 가지고 있는 쿠폰을 조회할 때, 해당 상품 ID를 넣어준다. */
  marketItemIDs?: number[];
}

export interface DomainListUserCouponsResponse {
  userCoupons: DomainUserCouponItem[];
}

export interface DomainListUserDailylooksResponse {
  /** 데일리룩 리스트 */
  dailylooks?: DomainDailylookResponse[];
  /**
   * 조회 타임스탬프
   * @example 1622544000000
   */
  searchTimestamp: number;
}

export interface DomainListUserDownloadableCouponsResponse {
  coupons: DomainCouponItem[];
}

export interface DomainListUserIdeasResponse {
  /** 아이디어 리스트 */
  ideas?: DomainIdeaResponse[];
  /**
   * 조회 타임스탬프
   * @example 1622544000000
   */
  searchTimestamp: number;
}

export interface DomainListUserMarketItemReviewsResponse {
  reviews?: DomainMarketItemReviewResponse[];
}

export interface DomainListUserMarketItemsResponse {
  /**
   * 다음 페이지가 있는지 여부
   * @example true
   */
  hasNext: boolean;
  marketItems?: DomainUserMarketItemResponse[];
}

export interface DomainListUserNearestCountriesResponse {
  countries: DomainCountryResponse[];
}

export interface DomainListUserSellerFollowsResponse {
  hasNext: boolean;
  proSellerUserItems: DomainProSellerUserItem[];
}

export interface DomainListUserWishlistsResponse {
  /** @example true */
  hasNext: boolean;
  wishlists?: DomainWishlistDTO[];
}

export interface DomainLogixPrice {
  /** @example 50 */
  jeju: number;
  /** @example 30 */
  normal: number;
  /** @example 50 */
  outlyingArea: number;
}

export type DomainLogixPriceType =
  | 'MARKET-ITEM_LOGIX-PRICE-TYPE_NORMAL'
  | 'MARKET-ITEM_LOGIX-PRICE-TYPE_OUTLYING-AREA'
  | 'MARKET-ITEM_LOGIX-PRICE-TYPE_JEJU';

export type DomainLogixType =
  | 'MARKET-ITEM_LOGIX-TYPE_PREPAID-SHIPPING-FEE'
  | 'MARKET-ITEM_LOGIX-TYPE_COLLECT-ON-DELIVERY'
  | 'MARKET-ITEM_LOGIX-TYPE_FREE'
  | 'MARKET-ITEM_LOGIX-TYPE_PAY'
  | 'MARKET-ITEM_LOGIX-TYPE_FREE-ON-AMOUNT';

export type DomainMarketItemBookmarkOrderField = 'marketItemID' | 'discountPrice' | 'discountRate' | 'bookmarkID';

export interface DomainMarketItemBrandItem {
  /** 해당 브랜드로 등록된 마켓아이템 수 */
  count?: number;
  /** 로고 이미지 주소 */
  logoUrl?: string;
  /** 브랜드 명 */
  name?: string;
}

export interface DomainMarketItemChatroomResponse {
  /**
   * 구매자 닉네임
   * @example "penguin"
   */
  BuyerNickname: string;
  /**
   * 채팅방과 연결된 중고 아이템 ID
   * @example false
   */
  IsMarketItemDeleted: boolean;
  /**
   * 구매자 유저 ID
   * @example 677235
   */
  buyerID: number;
  /**
   * 구매자 유저 프로필 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  buyerProfileImageURL?: string;
  /**
   * Sendbird ID (샌드버드 사용할 때 한정사용)
   * @example "sendbird_group_channel_25108471_a1bc35f5f0d237207bc1rd343562c878fc2fd426"
   */
  chatroomID: string;
  /**
   * 구매자의 회원 탈퇴 여부
   * @example false
   */
  isBuyerDeleted: boolean;
  /**
   * 판매자의 회원 탈퇴 여부
   * @example false
   */
  isSellerDeleted: boolean;
  /**
   * 채팅방 내역 ID (PK)
   * @example 12541
   */
  marketItemChatroomID: number;
  /**
   * 채팅방과 연결된 중고 아이템 ID
   * @example 16523667
   */
  marketItemID: number;
  /**
   * 채팅방과 연결된 중고 아이템 썸네일 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  marketItemImageURL: string;
  /** 중고 아이템 상태 */
  marketItemStatus: 'MARKET-ITEM_STATUS_SOLD' | 'MARKET-ITEM_STATUS_PROCESSING' | 'MARKET-ITEM_STATUS_FOR-SALE';
  /**
   * 판매자 유저 ID
   * @example 1251235
   */
  sellerID: number;
  /**
   * 판매자 닉네임
   * @example "penguin"
   */
  sellerNickname: string;
  /**
   * 판매자 유저 프로필 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  sellerProfileImageURL?: string;
}

export interface DomainMarketItemImageRequest {
  /**
   * 이미지 높이
   * @example 100
   */
  height: number;
  /**
   * 대표이미지 여부
   * @example true
   */
  isMain: boolean;
  /**
   * 이미지 순서
   * @example 1
   */
  order: number;
  /**
   * image url
   * @example "url"
   */
  url: string;
  /**
   * 이미지 폭
   * @example 100
   */
  width: number;
}

export interface DomainMarketItemImageResponse {
  /**
   * 중고 아이템과 연결된 옷 ID
   * @example 1621
   */
  imageID: number;
  /** @example 1 */
  imageOrder: number;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  imageURL: string;
  /** @example true */
  isMain: boolean;
  /** @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp" */
  thumbnailURL: string;
}

export type DomainMarketItemOrderField =
  | 'marketItemID'
  | 'discountPrice'
  | 'discountRate'
  | 'createDate'
  | 'modifyDate'
  | '_score';

export type DomainMarketItemRaglanType =
  | 'MARKET-ITEM_RAGLAN-TYPE_NORMAL'
  | 'MARKET-ITEM_RAGLAN-TYPE_TOP'
  | 'MARKET-ITEM_RAGLAN-TYPE_ONEPIECE';

export interface DomainMarketItemResponse {
  /**
   * 해당 중고 물품에 북마크 한 수
   * @example 1
   */
  bookmarkCount: number;
  /**
   * 중고 옷 브랜드명
   * @example "SOUTH FACE"
   */
  brandName: string;
  /**
   * 중고 아이템 구매자 유저 ID
   * @example 22612346
   */
  buyerID?: number;
  /** @example 2626123 */
  clothesID?: number;
  /**
   * 중고 아이템 국가 코드
   * @example "KR"
   */
  countryCode: string;
  /**
   * 중고 아이템 생성일
   * @example 1668080178342
   */
  createDate: number;
  /**
   * TODO: 아래필드는 삭제 예정 (4.4.0) <-- 진짜 삭제하는지 확인
   * @example "KRW"
   */
  currency: string;
  /**
   * 중고 아이템 설명
   * @example "사실 2년 입었어유"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 2000
   */
  discountPrice: number;
  /**
   * 중고 아이템 할인율
   * @example 30
   */
  discountRate: number;
  /** @example "MARKET-ITEM_FABRIC_COTTON" */
  fabric: string;
  /**
   * 조건부 무료 배송 조건
   * @example 1000
   */
  freeOnAmount: number;
  /** @example false */
  isBookmarked: boolean;
  /**
   * 중고 아이템 삭제 여부
   * @example false
   */
  isDeleted: boolean;
  /**
   * 프로셀러 여부
   * @example true
   */
  isProSeller: boolean;
  /** 비슷한 상품 여부 */
  isSimilar?: boolean;
  /**
   * 지점명 노출 여부
   * @example true
   */
  isVisible: boolean;
  /**
   * 중고 아이템 검색 키워드
   * @example ["흰색","티셔츠","남성"]
   */
  keywords: string[];
  /**
   * 공급사명(지점명)
   * @example "공급사 없음"
   */
  logixName: string;
  logixPrice: DomainLogixPrice;
  logixType: DomainLogixType;
  /** @example 1246561453 */
  marketItemID: number;
  /**
   * 중고 아이템 수정일
   * @example 1668080178342
   */
  modifyDate: number;
  /**
   * 중고 아이템 가격
   * @example 3000
   */
  price: number;
  /**
   * 중고 아이템의 상태 (깨끗함, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  /**
   * 중고 옷 사이즈
   * @example "FREE"
   */
  size: string;
  /** 중고 아이템 판매 상태 */
  status: DomainMarketItemStatus;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  thumbnailURL: string;
  /**
   * 중고 아이템 제목
   * @example "새것 같은 노스페이스 패딩 팔아유"
   */
  title: string;
  /**
   * 중고 아이템 판매자 유저 ID
   * @example 22612346
   */
  userID: number;
  /** 와우 할인가 */
  wowDiscountAmount?: number;
}

export interface DomainMarketItemReviewResponse {
  /**
   * 리뷰 내용
   * @example "1시간 늦게 나왔네요"
   */
  comment: string;
  /**
   * 리뷰 생성일시
   * @example 1668080178342
   */
  createDate: number;
  /**
   * 리뷰를 하는 사람의 회원탈퇴 여부
   * @example false
   */
  isReviewerDeleted: boolean;
  /**
   * 리뷰와 연결된 중고 ID
   * @example 125156
   */
  marketItemID: number;
  /**
   * 로그인 한 유저가 답글 리뷰를 작성한 경우 해당 리뷰 ID (작성하지 않은 경우 null)
   * @example 12512563
   */
  myReviewID?: number;
  /**
   * 리뷰 평점
   * @example 0.5
   */
  rating: number;
  /**
   * 리뷰 ID (PK)
   * @example 24521
   */
  reviewID: number;
  /** 리뷰를 받는 사람 */
  reviewee: DomainReviewUserResponse;
  /** 리뷰를 하는 사람 */
  reviewer: DomainReviewUserResponse;
}

export type DomainMarketItemReviewType = 'MARKET-ITEM_REVIEW-TYPE_BUYING' | 'MARKET-ITEM_REVIEW-TYPE_SELLING';

export type DomainMarketItemShoulderPadType =
  | 'MARKET-ITEM_SHOULDER-PAD-TYPE_NORMAL'
  | 'MARKET-ITEM_SHOULDER-PAD-TYPE_TOP'
  | 'MARKET-ITEM_SHOULDER-PAD-TYPE_ONEPIECE';

export type DomainMarketItemStatus =
  | 'MARKET-ITEM_STATUS_SOLD'
  | 'MARKET-ITEM_STATUS_PROCESSING'
  | 'MARKET-ITEM_STATUS_FOR-SALE'
  | 'MARKET-ITEM_STATUS_STOP-SALE';

export type DomainMarketItemWaistBandingType =
  | 'MARKET-ITEM_WAIST-BANDING-TYPE_NORMAL'
  | 'MARKET-ITEM_WAIST-BANDING-TYPE_TOP'
  | 'MARKET-ITEM_WAIST-BANDING-TYPE_ONEPIECE';

export interface DomainMetadataDescriptionResponse {
  en?: string;
  es?: string;
  fr?: string;
  ko?: string;
  ru?: string;
}

export interface DomainMetadataResponse {
  code: string;
  description?: DomainMetadataDescriptionResponse;
  domain?: string;
  subDomain?: string;
}

export interface DomainMiddleCategory {
  bottomCategory?: DomainBottomCategory[];
  id?: string;
  name?: string;
}

export interface DomainMostWornClothesResponse {
  /**
   * 브랜드 이름
   * @example "ZARA"
   */
  brandName: string;
  /**
   * 옷 아이디
   * @example 12345
   */
  clothesID: number;
  /**
   * 썸네일 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/166807971815507578418_calendars.webp"
   */
  thumbnailURL: string;
  /**
   * 입은 횟수
   * @example 6
   */
  wornCount: number;
}

export interface DomainNotificationContent {
  /** @example "kevin" */
  content: string;
  /** @example "https://acloset.style/kevin" */
  deeplink: string;
}

export interface DomainNotificationResponse {
  /** 알림 컨텐츠 */
  contents: Record<string, DomainNotificationContent>;
  /**
   * 생성 날짜
   * @example 1668080178342
   */
  createDate: number;
  /**
   * 이미지 URL
   * @example "https://example.com/image.png"
   */
  imageURL?: string;
  /**
   * 알림 메시지 "읽음" 여부
   * @example false
   */
  isSeen: boolean;
  /**
   * 알림 딥링크
   * @example "https://acloset.style/idea/3"
   */
  notificationDeeplink: string;
  /**
   * 알림 아이디
   * @example 1
   */
  notificationID: number;
  /**
   * 알림 텍스트
   * @example "{user}님이 내 코디를 좋아합니다"
   */
  notificationText: string;
  /**
   * 프로필 이미지 URL
   * @example "https://example.com/image.png"
   */
  profileImageURL?: string;
}

export interface DomainOfficialBrandDto {
  childBrands?: string[];
  isFollowing?: boolean;
  logoUrl: string;
  mainImage: string;
  marketItemCount?: number;
  marketItems?: DomainMarketItemResponse[];
  nameEn: string;
  nameKr: string;
  officialBrandID: number;
  totalMarketItemCount?: number;
}

export interface DomainOpenWowDiscountRequest {
  wowDiscountID: number;
}

export interface DomainOrderBuyerLogix {
  additionalAddress: string;
  address: string;
  memo?: string;
  name: string;
  phone: string;
  roadAddress: string;
  zoneCode: string;
}

export interface DomainOrderCancelDTO {
  /** 취소 금액 */
  amount?: number;
  /** 취소 ID */
  id?: number;
  /** 취소 상품 */
  orderCancelItems?: DomainOrderCancelItemDTO[];
}

export interface DomainOrderCancelItemDTO {
  /** 주문 상품 ID */
  id?: number;
  /** 마켓 아이템 ID */
  marketItemID?: number;
  /** 가격 스냅샷 */
  marketItemPrice?: number;
  /** 썸네일 스냅샷 */
  marketItemThumbnail?: string;
  /** 타이틀 스냅샷 */
  marketItemTitle?: string;
  /** 주문 취소 ID */
  orderCancelID?: number;
  /** 주문 ID */
  orderID?: number;
  /** 취소 할 주문 상품 ID */
  orderItemID?: number;
  /** 취소 상세 사유 */
  reason?: string;
  /** 취소 귀책 사유 */
  reasonType?: DomainOrderCancelReasonType;
}

export type DomainOrderCancelReasonType = 'BUYER' | 'SELLER' | 'ADMIN';

export interface DomainOrderDTO {
  /** 상품 금액 */
  amount?: number;
  /** 구매자 이메일 */
  buyerEmail?: string;
  /** 구매자 ID */
  buyerID?: number;
  /** 구매자 연락처 */
  buyerMobile?: string;
  /** 구매자 닉네임 */
  buyerNickname?: string;
  /** 취소 내역 */
  cancels?: DomainOrderCancelDTO[];
  /** 주문 생성일 */
  createDate?: string;
  /** 조건부 무료 조건 금액 */
  freeConditionalAmount?: number;
  /** 주문 ID */
  id?: number;
  /** 주문 상품 */
  items?: DomainOrderItemDTO[];
  /** 배송 상세 주소 */
  logixAdditionalAddress?: string;
  /** 배송 주소 */
  logixAddress?: string;
  /** 배송 메모 */
  logixMemo?: string;
  /** 배송 받는 사람 이름 */
  logixName?: string;
  /** 배송 받는 사람 연락처 */
  logixPhone?: string;
  /** 실제 지불 배송비 */
  logixPrice?: number;
  /** 배송비 타입 (제주, 도서산간) */
  logixPriceType?: DomainLogixPriceType;
  /** 반품 배송비 */
  logixReturnPrice?: number;
  /** 배송비 타입 (무료, 유료, 조건부 무료) */
  logixType?: DomainLogixType;
  /** 배송지 우편 번호 */
  logixZipCode?: string;
  /** 총 결제 금액 */
  paidAmount?: number;
  /** 지불 방법 */
  payMethod?: DomainPayMethod;
  /** 반품 내역 */
  returns?: DomainOrderReturnDTO[];
  /** 판매자 ID */
  sellerID?: number;
  /** 판매자 닉네임 */
  sellerNickname?: string;
  /** 결제 금액 + 배송비 */
  totalAmount?: number;
  /** 설정 배송비 */
  txLogixPrice?: number;
}

export type DomainOrderDisputeReasonType = 'BUYER' | 'SELLER';

export interface DomainOrderForLookoAIResponse {
  /** 상품 금액 */
  amount?: number;
  /** 구매자 이메일 */
  buyerEmail?: string;
  /** 구매자 ID */
  buyerID?: number;
  /** 구매자 연락처 */
  buyerMobile?: string;
  /** 구매자 닉네임 */
  buyerNickname?: string;
  /** 취소상품 주문 금액 */
  cancelAmount?: number;
  /** 취소 내역 */
  cancels?: DomainOrderCancelDTO[];
  /** 주문 생성일 */
  createDate?: string;
  /** 조건부 무료 조건 금액 */
  freeConditionalAmount?: number;
  /** 주문 ID */
  id?: number;
  /** 주문 상품 */
  items?: DomainOrderItemDTO[];
  /** 배송 상세 주소 */
  logixAdditionalAddress?: string;
  /** 배송 주소 */
  logixAddress?: string;
  /** 배송 메모 */
  logixMemo?: string;
  /** 배송 받는 사람 이름 */
  logixName?: string;
  /** 배송 받는 사람 연락처 */
  logixPhone?: string;
  /** 실제 지불 배송비 */
  logixPrice?: number;
  /** 배송비 (차감) */
  logixPriceDeducted?: number;
  /** 배송비 차감 여부 */
  logixPriceDeduction?: boolean;
  /** 배송비(합산) */
  logixPricePaid?: number;
  /** 배송비 합산여부 */
  logixPricePaidSummation?: boolean;
  /** 배송비 타입 (제주, 도서산간) */
  logixPriceType?: DomainLogixPriceType;
  /** 반품 배송비 */
  logixReturnPrice?: number;
  /** 배송비 타입 (무료, 유료, 조건부 무료) */
  logixType?: DomainLogixType;
  /** 배송지 우편 번호 */
  logixZipCode?: string;
  /** 총 결제 금액 */
  paidAmount?: number;
  /** 지불 방법 */
  payMethod?: DomainPayMethod;
  /** 환불 금액 */
  refundAmount?: number;
  /** 환불금액 차감내역 */
  refundDeduction?: number;
  /** 취소 상품금액 */
  refundItemsPrice?: number;
  /** 환불 가능 여부 */
  refundable?: boolean;
  /** 반품 내역 */
  returns?: DomainOrderReturnDTO[];
  /** 판매자 ID */
  sellerID?: number;
  /** 판매자 닉네임 */
  sellerNickname?: string;
  /** 결제 금액 + 배송비 */
  totalAmount?: number;
  /** 설정 배송비 */
  txLogixPrice?: number;
}

export interface DomainOrderItemDTO {
  createDate?: string;
  id?: number;
  logixCourierName?: string;
  logixTrackingNumber?: string;
  marketItemBrand?: string;
  marketItemID?: number;
  marketItemPrice?: number;
  marketItemThumbnail?: string;
  marketItemTitle?: string;
  status?: DomainOrderStatus;
}

export interface DomainOrderItemDetailDto {
  cancelDate?: number;
  cancellationActor?: DomainOrderCancelReasonType;
  cancellationReason?: DomainCancelOrderReason;
  cancellationReasonDetail?: string;
  /** sendbird chat url */
  chatUrl?: string;
  /** 구매확정일 */
  confirmDate?: string;
  /** 구매확정예정일 */
  confirmTxDueDate: string;
  /** 주문 생성 일시 */
  createDate: string;
  /** 주문 상세 id */
  id: number;
  /** 구매확정 연장 여부 */
  isExtend?: boolean;
  /** 택배사 이름 */
  logixCourierName: string;
  /** 운송장 번호 */
  logixTrackingNumber: string;
  /** 상품 브랜드 snapshot */
  marketItemBrand: string;
  /** 상품 ID */
  marketItemID: number;
  /** 상품 가격 snapshot */
  marketItemPrice: number;
  /** 상품 썸네일 snapshot */
  marketItemThumbnail: string;
  /** 상품 이름 snapshot */
  marketItemTitle: string;
  /** 주문 수정 일시 */
  modifyDate: string;
  /** reviewID */
  myReviewID?: number;
  /** 주문 번호 */
  orderNumber: string;
  /** 반품 요청 횟수 */
  refundCount: number;
  /** 주문 상태 필요 여부에따라 남길지 지울지 정해짐 */
  status: DomainOrderStatus;
}

export interface DomainOrderItemForBackofficeDTO {
  /** 수수료 */
  agentFee?: number;
  /** 수수료 할인 금액 */
  agentFeeDiscount?: number;
  /** 수수료 할인 타입 */
  agentFeeDiscountType?: string;
  /** 구매자 이메일 */
  buyerEmail?: string;
  /** 구매자 ID */
  buyerID: number;
  /** 구매자 닉네임, snapshot */
  buyerNickname?: string;
  /** 구매자 연락처 */
  buyerNumber?: string;
  /** 구매 확정일 */
  confirmDate?: number;
  /** 구매 확정 예정일 */
  confirmDueDate?: number;
  /** 거래생성 unix timestamp */
  createdAt: number;
  /** 구매자 탈퇴 여부 */
  isDeleteBuyer: boolean;
  /** 판매자 탈퇴 여부 */
  isDeleteSeller: boolean;
  /** 프로셀러 여부 */
  isProSeller: boolean;
  /** 택배사 이름 */
  logixCourierName?: string;
  /** 운송장 번호 */
  logixTrackingNumber?: string;
  marketItemBrand: string;
  /** 상품 ID */
  marketItemID: number;
  /** 상품 가격 snapshot */
  marketItemPrice: number;
  /** 상품 썸네일 snapshot */
  marketItemThumbnail: string;
  /** 상품 이름 snapshot */
  marketItemTitle: string;
  /** 거래 수정일 */
  modifyAt: number;
  /** 주문 ID */
  orderID: number;
  /** 상품주문 ID */
  orderItemID: number;
  /** 상품주문 번호 */
  orderNumber: string;
  /** 결제 금액 */
  paidAmount: number;
  /** 결제 일시 */
  paidAt: number;
  /** 결제 수단 */
  payMethod: DomainPayMethod;
  /** 판매자 이메일 */
  sellerEmail?: string;
  /** 판매자 ID */
  sellerID: number;
  /** 판매자 닉네임, snapshot */
  sellerNickname?: string;
  /** 판매자 연락처 */
  sellerNumber?: string;
  /** 주문 상태 */
  status: DomainOrderStatus;
}

export interface DomainOrderItemListDto {
  buyerID: number;
  buyerNickname: string;
  /** 주문 생성 일시 */
  createDate: string;
  isDeleteBuyer: boolean;
  isDeleteSeller: boolean;
  isProSeller: boolean;
  /** 상품 썸네일 snapshot */
  marketItemBrand: string;
  /** 상품 ID */
  marketItemID: number;
  /** 상품 가격 snapshot */
  marketItemPrice: number;
  /** 상품 썸네일 snapshot */
  marketItemThumbnail: string;
  /** 상품 이름 snapshot */
  marketItemTitle: string;
  /** 주문 수정 일시 */
  modifyDate: string;
  myReviewID?: number;
  /** 주문 번호 (213489-01) */
  orderNumber: string;
  /** 사용자 정보 */
  sellerID: number;
  sellerNickname: string;
  /** 주문 상태 필요 여부에따라 남길지 지울지 정해짐 */
  status: DomainOrderStatus;
  /** 구매 생성 일 (1970.01.02) */
  txDate: string;
  /** 주문 상세 id */
  txDetailID: number;
  /** 거래 id */
  txID: number;
}

export interface DomainOrderItemLogix {
  courierName?: string;
  orderItemID?: number;
  trackingNumber?: string;
}

export interface DomainOrderReturnDTO {
  /** 메모 */
  address?: string;
  /** 상세주소 */
  addressDetails?: string;
  /** 반품 생성일 */
  createdAt?: string;
  /** 반품 ID */
  id?: number;
  /** 반품 사진 */
  images?: string[];
  /** 반품 배송비 */
  logixReturnPrice?: number;
  /** 반품 배송비 차감여부 */
  logixReturnPriceDeduction?: boolean;
  /** 반품 방법 */
  method?: DomainRefundLogixType;
  /** 수거 정보의 사람 이름 */
  name?: string;
  /** 주문 ID */
  orderID?: number;
  /** 반품 상품 */
  orderReturnItems?: DomainOrderReturnItemDTO[];
  /** 연락처 */
  phone?: string;
  /** 귀책 사유 (판매자 또는 구매자) */
  reason?: DomainRefundReason;
  /** 귀책 상세 사유 */
  reasonDetails?: string;
  /** 귀책 사유 타입 (판매자 또는 구매자) */
  reasonType?: DomainOrderReturnReasonType;
  /** 우편번호 */
  zipCode?: string;
}

export interface DomainOrderReturnItemDTO {
  /** 반품 상품 ID */
  id?: number;
  /** 마켓 아이템 ID */
  marketItemID?: number;
  /** 가격 스냅샷 */
  marketItemPrice?: number;
  /** 썸네일 스냅샷 */
  marketItemThumbnail?: string;
  /** 타이틀 스냅샷 */
  marketItemTitle?: string;
  /** 주문 ID */
  orderID?: number;
  /** 취소 할 주문 상품 ID */
  orderItemID?: number;
  /** 주문 취소 ID */
  orderReturnID?: number;
  /** 귀책 사유 (단순 변심, 상품 오배송 등) */
  reason?: DomainRefundReason;
  /** 귀책 상세 사유 */
  reasonDetails?: string;
  /** 귀책 사유 타입 (판매자 또는 구매자) */
  reasonType?: DomainOrderReturnReasonType;
  /** 반품 상태 */
  status?: DomainOrderReturnStatus;
}

export type DomainOrderReturnReasonType = 'BUYER' | 'SELLER';

export type DomainOrderReturnStatus = 'REQUEST' | 'APPROVED' | 'DENIED' | 'DENIED_AND_CONFIRM';

export type DomainOrderStatus =
  | 'TX_STATUS_CANCELED'
  | 'TX_STATUS_PAYMENT-PENDING'
  | 'TX_STATUS_PAYMENT-COMPLETED'
  | 'TX_STATUS_SHIPPING-PREPARING'
  | 'TX_STATUS_SHIPPING-IN-TRANSIT'
  | 'TX_STATUS_TRANSACTION-COMPLETED-SAFE'
  | 'TX_STATUS_REFUND-REVIEW'
  | 'TX_STATUS_REFUND-WAIT'
  | 'TX_STATUS_REFUND-DENIED'
  | 'TX_STATUS_REFUND-COMPLETED';

export type DomainOrderType = 'SELL' | 'BUY';

export interface DomainPatchClothesRequest {
  categoryID?: number;
  clothesID?: number;
  /** 배경 제거된 이미지 */
  clothesImagePath?: string;
  clothesImageURL?: string;
  colors?: number[];
  materials?: number[];
  occasions?: number[];
  /** 배경 제거 안된 이미지 */
  originalClothesImagePath?: string;
  originalClothesImageURL?: string;
  patterns?: number[];
  tags?: string[];
}

export interface DomainPatchCouponRequest {
  allowDuplicateUsage?: boolean;
  couponCalcType?: DomainCouponCalcType;
  couponCode?: string;
  couponConditions?: DomainCouponConditionDTO[];
  couponContentImages?: string[];
  couponDescription?: string;
  couponID: number;
  couponImage?: string;
  couponIssueButtonImage?: string;
  couponName?: string;
  couponUsageMax?: number;
  discountAmount?: number;
  discountAmountMax?: number;
  eventEndDate?: string;
  eventStartDate?: string;
  expirationDuration?: number;
  isActivate?: boolean;
  txAmountMin?: number;
}

export interface DomainPatchLogixPrice {
  /** @example 50 */
  jeju: number;
  /** @example 30 */
  normal: number;
  /** @example 50 */
  outlyingArea: number;
}

export type DomainPatchMarketItemAsSellingRequest = object;

export interface DomainPatchMarketItemRequest {
  discountPrice?: number;
  status?: DomainMarketItemStatus;
}

export interface DomainPatchUserProSellerRequest {
  /** 예금주 */
  accountHolder?: string;
  /** 계좌번호 */
  accountNumber?: string;
  backgroundImageURL?: string;
  /** 은행명 */
  bankName?: string;
  bio?: string;
  businessAddress?: string;
  businessContact?: string;
  /** proseller_info 테이블 반영 */
  businessName?: string;
  inquiryContact?: string;
  inquiryPossibleTime?: string;
  isProductionVisible?: boolean;
  link?: string;
  logixPriceByArea?: boolean;
  /** nc_usr_account 테이블 반영 */
  nickname?: string;
  /**
   * `MARKET-ITEM_LOGIX-TYPE_PREPAID-SHIPPING-FEE` 현재 api 에서 허용안함<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_COLLECT-ON-DELIVERY` 현재 api 에서 허용안함<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_FREE` 배송비 무료<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_PAY` 배송비 유료 (logixPrice 필수)<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_FREE-ON-AMOUNT` 배송 (order_logix_type_free_on_amount 필수)<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_PAY-ON-QUANTITY` 배송 (order_logix_type_pay_on_quantity 필수)<br/>
   */
  orderLogixType?: DomainLogixType;
  /** MARKET-ITEM_LOGIX-TYPE_FREE-ON_AMOUNT 선택시 무료 배송이 되는 금액, 입력시 최소 1이상 */
  orderLogixTypeFreeOnAmount?: number;
  /** MARKET-ITEM_LOGIX-TYPE_PAY-ON-QUANTITY 선택시 지정된 갯수마다 배송비 부과, 입력시 최소 1 이상 */
  orderLogixTypePayOnQuantity?: number;
  orderShippingFee?: DomainPatchLogixPrice;
  proSellerInterviewImages?: string[];
  profileImageURL?: string;
  purchaseQuantityLimit?: number;
  refundAddressInfo?: DomainAddressInfoProSeller;
  refundCourierName?: string;
  refundLogixType?: DomainRefundLogixType;
  refundPolicy?: string;
  refundShippingFee?: DomainPatchLogixPrice;
}

export interface DomainPatchUserRequest {
  /**
   * 변경할 프로필 - 배경이미지 (수정 안할 시 null)
   * @example "https://www.naver.com"
   */
  backgroundImageURL?: string;
  /**
   * 변경할 프로필 - 소개문구 (수정 안할 시 null)
   * @example "ㅎㅇㅎㅇ 여러분"
   */
  bio?: string;
  /**
   * 변경할 생일 [FORMAT: YYYY-MM-DD](수정 안할 시 null)
   * @example "1997-01-30"
   */
  birth?: string;
  /**
   * 변경할 클라이언트 설정 (수정 안할 시 null)
   * @example "{"ClientConfig":"hello"}"
   */
  clientConfig?: string;
  /**
   * 변경할 덧글 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  commentNotificationAgreed?: boolean;
  /**
   * 변경할 국가 코드 (수정 안할 시 null)
   * @example "true"
   */
  countryCode?: string;
  /**
   * 변경할 통화 단위 코드 (수정 안할 시 null)
   * @example "USD"
   */
  currency?: string;
  /**
   * 변경할 팔로우 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  followNotificationAgreed?: boolean;
  /** 변경할 유저 성별(MALE:남성, FEMALE:여성, RATHERNOTSAY:밝히지 않음, NONBINARY: 지정되지 않음) (수정 안할 시 null) */
  gender?: 'MALE' | 'FEMALE' | 'RATHERNOTSAY' | 'NONBINARY';
  /**
   * 변경할 사용자 이메일 인증 여부 (수정 안할 시 null)a
   * @example true
   */
  isVerified?: boolean;
  /**
   * 변경할 사용어 언어코드 (수정 안할 시 null)
   * @example "ko"
   */
  language?: string;
  /**
   * 변경할 좋아요 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  likeNotificationAgreed?: boolean;
  /**
   * 변경할 프로필 - 웹사이트 (수정 안할 시 null)
   * @example "https://www.naver.com"
   */
  link?: string;
  /**
   * 변경할 중고 북마크 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  marketItemBookmarkNotificationAgreed?: boolean;
  /**
   * 변경할 중고 채팅 푸시 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  marketItemChattingPushNotificationAgreed?: boolean;
  /**
   * 변경할 중고 할인 푸시 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  marketItemDiscountPushNotificationAgreed?: boolean;
  /**
   * 변경할 중고 리뷰 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  marketItemReviewNotificationAgreed?: boolean;
  /**
   * 마이그레이션 진행 대상자인지 확인 (수정 안할 시 null)
   * @example true
   */
  migrationFlag?: boolean;
  /**
   * 변경할 닉네임 (수정 안할 시 null)
   * @example "코딩하는기린"
   */
  nickname?: string;
  /**
   * 변경할 코디 나만 보기 모드 (수정 안할 시 null)
   * @example true
   */
  outfitPrivacy?: boolean;
  /**
   * 변경할 코디 추천 대상 옷장 ID리스트 (수정 안할 시 null) ⚠️ 빈 리스트로 보낼 경우 추천 대상 옷장이 모든 옷으로 됨
   * @example [11,55,122]
   */
  prefClosetIDs?: number[];
  /**
   * 변경할 코디 추천 온도감 설정(-2: 더 따뜻하게 입을래요, -1: 조금 따뜻하게 입을래요, 0: 적당해요, 1: 조금 시원하게 입을래요, 2: 더 시원하게 입을래요) (수정 안할 시 null)
   * @example 1
   */
  tempSenseLevel?: -2 | -1 | 0 | 1 | 2;
  /**
   * 변결할 거래 푸시 알림 허용 여부(수정 안할 시 null)
   * @example true
   */
  transactionPushNotificationAgreed?: boolean;
  /**
   * 변경할 업데이트 알림 허용 여부 (수정 안할 시 null)
   * @example true
   */
  updateNotificationAgreed?: boolean;
}

export interface DomainPatchWishlistRequest {
  /**
   * 알람 여부
   * @example true
   */
  isNotification?: boolean;
  /**
   * 새로 생성된 아이템을 확인했는지 여부 (true: 확인함, false: 확인하지 않음)
   * @example true
   */
  isSeen?: boolean;
  /**
   * 빈 문자열은 안됨. 글자수 제한 없음
   * @example "스포츠 관심상품"
   */
  name?: string;
}

export type DomainPayMethod = 'card' | 'kakaopay' | 'naverpay' | 'tosspay' | 'trans';

export interface DomainPrefClosets {
  /**
   * 선호하는 옷장 아이디들
   * @example [1]
   */
  closetIDs?: number[];
  /**
   * 모든 옷장 사용 여부
   * @example false
   */
  isAll: boolean;
}

export interface DomainProSellerInfo {
  businessAddress?: string;
  businessContact?: string;
  businessName?: string;
  inquiryContact?: string;
  inquiryPossibleTime?: string;
  isProductionVisible?: boolean;
  orderLogixType?: DomainLogixType;
  orderLogixTypeFreeOnAmount?: number;
  orderLogixTypePayOnQuantity?: number;
  orderShippingFee?: DomainLogixPrice;
  /** 임시 서비스, 프로셀러가 최대 200명 내외 */
  proSellerInterviewImages?: string[];
  purchaseQuantityLimit?: number;
  refundAddressInfo?: DomainAddressInfoProSeller;
  refundCourierName?: string;
  refundLogixType?: DomainRefundLogixType;
  refundPolicy?: string;
  refundShippingFee?: DomainLogixPrice;
  userID?: number;
}

export interface DomainProSellerLogixDTO {
  /** CS 담당 연락처 */
  afterServicePhoneNumber: string;
  /** 택배사 */
  courierCompany: string;
  /** 무료 배송 조건(배송료가 무료가 되는 주문금액) */
  freeOnAmount: number;
  /** 공급사명 노출 여부 */
  isVisible: boolean;
  /** 지역 별 배송비 사용 여부 */
  logixFeeByArea: boolean;
  /** 배송정보 ID */
  logixID: number;
  /** 공급사명(지점명) */
  logixName: string;
  /** 배송비 */
  logixPrice: DomainLogixPrice;
  /** 배송 타입 */
  logixType: DomainLogixType;
  /** 프로 셀러 ID */
  proSellerID: number;
  /** 최대 구매 수량 */
  purchaseQuantity: number;
  /** 수거 방법 */
  refundLogixType: DomainRefundLogixType;
  /** 반품 주소 */
  returnAddress: string;
  /** 반품 상세 주소 */
  returnAddressDetail: string;
  /** 반품 배송비 */
  returnFee: number;
  /** 반품 이름 */
  returnName?: string;
  /** 반품 정책 */
  returnPolicy: string;
  /** 반품 우편 번호 */
  returnZipCode: string;
}

export interface DomainProSellerUserItem {
  /** 상점 소개 */
  bio?: string;
  /** 상품수가 많은 브랜드 3개 */
  brandTop3?: string[];
  /** 상점 이미지 */
  images?: string[];
  /** 조회한 유저 기준 팔로우 여부 */
  isFollowing?: boolean;
  /** 상점 노출 여부 */
  isVisibleProSeller?: boolean;
  /** 해당 프로셀러의 상품 수 */
  marketItemCount?: number;
  nickname?: string;
  /** 프로필 이미지 */
  profileImage?: string;
  userID?: number;
}

export interface DomainPromotionDisplay {
  /** @example "https://image.com/banner.png" */
  bannerImageURL: string;
  /** @example ["컨텐츠 이미지"] */
  contentImageURLs?: string[];
  /** @example "프로모션 제목" */
  promotionTitle: string;
  /** @example "" */
  sellerNickname?: string;
}

export interface DomainPromotionDisplayRequest {
  /** @example "https://image.com/banner.png" */
  bannerImageURL: string;
  /** @example ["컨텐츠 이미지"] */
  contentImageURLs?: string[];
  /** @example "프로모션 제목" */
  promotionTitle: string;
  /** @example "" */
  sellerNickname?: string;
}

export interface DomainPromotionInfo {
  GAParameter: string;
  /** @example 1 */
  order: number;
  /**
   * web
   * 		- 쿼리/키워드: webservice/path (서버)
   * 		- 판매자 프로필 유형: "" (프론트)
   * 		- 외부유형: /path (백오피스)
   * 		app
   * 		- 쿼리/키워드: /path (서버)
   * 		- 판매자 프로필 유형: "" (프론트)
   * 		- 외부유형: /path (백오피스)
   * @example "/market-items"
   */
  path: string;
  promotionDisplay: DomainPromotionDisplay;
  /**
   * 프론트에서 사용하는 키 (unix second)
   * @example 1687324366
   */
  promotionKey: number;
  promotionQuery: DomainPromotionQuery;
  promotionType: DomainPromotionType;
}

export interface DomainPromotionInfoHistory {
  createDate: string;
  promotionInfoHistoryID: number;
  promotionInfos: DomainPromotionInfo[];
}

export interface DomainPromotionInfoRequest {
  GAParameter: string;
  /** @example 1 */
  order: number;
  /**
   * web
   * 		- 쿼리/키워드: webservice/path (서버)
   * 		- 판매자 프로필 유형: "필요없음" (프론트)
   * 		- 외부유형: /path (백오피스)
   * 		- 이미지/컨텐츠: "필요없음" (서버)
   * 		- 쿠폰 유형: "필요없음" (서버)
   * 		app
   * 		- 쿼리/키워드: /path (서버)
   * 		- 판매자 프로필 유형: "필요없음" (프론트)
   * 		- 외부유형: /path (백오피스)
   * 		- 이미지/컨텐츠: "필요없음" (서버)
   * 		- 쿠폰 유형: "필요없음" (서버)
   * @example "/market-items"
   */
  path: string;
  promotionDisplay: DomainPromotionDisplayRequest;
  /**
   * 프론트에서 사용하는 키 (unix second)
   * @example 1687324366
   */
  promotionKey: number;
  promotionQuery: DomainPromotionQueryRequest;
  promotionType:
    | 'MARKET_ITEM_FILTER'
    | 'MARKET_ITEM_SEARCH'
    | 'MARKET_ITEM_EXTERNAL_URL'
    | 'MARKET_ITEM_SELLER_PROFILE'
    | 'MARKET_ITEM_IMAGE_CONTENT'
    | 'COUPON';
}

export interface DomainPromotionQuery {
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /** @example 1 */
  couponID?: number;
  /** @example 50 */
  discountRateMax?: number;
  /** @example 10 */
  discountRateMin?: number;
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?: string;
  /**
   * 무료 배송만
   * @example true
   */
  isFreeShipping?: boolean;
  /**
   * 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /** @example 1 */
  sellerID?: number;
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: DomainMarketItemStatus[];
  /** @example "" */
  textSearch?: string;
}

export interface DomainPromotionQueryRequest {
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  couponID?: number;
  /** @example 50 */
  discountRateMax?: number;
  /** @example 10 */
  discountRateMin?: number;
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?: string;
  /**
   * 무료 배송만
   * @example true
   */
  isFreeShipping?: boolean;
  /**
   * 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /** @example 1 */
  sellerID?: number;
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: DomainMarketItemStatus[];
  /** @example "" */
  textSearch?: string;
}

export type DomainPromotionType =
  | 'MARKET_ITEM_FILTER'
  | 'MARKET_ITEM_SEARCH'
  | 'MARKET_ITEM_EXTERNAL_URL'
  | 'MARKET_ITEM_SELLER_PROFILE'
  | 'MARKET_ITEM_IMAGE_CONTENT'
  | 'COUPON';

export interface DomainQuery {
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /** @example 50 */
  discountRateMax?: number;
  /** @example 10 */
  discountRateMin?: number;
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?: string;
  /**
   * 무료 배송만
   * @example true
   */
  isFreeShipping?: boolean;
  /**
   * 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /** @example 1 */
  sellerID?: number;
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: string[];
  /** @example "" */
  textSearch?: string;
}

export interface DomainQueryRequest {
  /**
   * 포함할 브랜드
   * @example ["NIKE","ADIDAS"]
   */
  brandNames?: string[];
  /**
   * 포함할 카테고리 ID
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 포함할 컬러 ID
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /** @example 50 */
  discountRateMax?: number;
  /** @example 10 */
  discountRateMin?: number;
  /**
   * 포함할 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear?: string;
  /**
   * 무료 배송만
   * @example true
   */
  isFreeShipping?: boolean;
  /**
   * 최대 가격
   * @example 100000
   */
  priceMax?: number;
  /**
   * 최소 가격 (최소 가격 0 이상)
   * @example 10000
   */
  priceMin?: number;
  /**
   * 포함할 상품 상태
   * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
   */
  qualities?: (
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
  )[];
  /** @example 1 */
  sellerID?: number;
  /**
   * 포함할 판매 상태
   * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
   */
  statuses?: string[];
  /** @example "" */
  textSearch?: string;
}

export interface DomainRecentlyWornClothesResponse {
  /**
   * 옷 아이디
   * @example 12345
   */
  clothesID: number;
  /**
   * 썸네일 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/166807971815507578418_calendars.webp"
   */
  thumbnailURL: string;
}

export interface DomainRecommSectionInfoHistory {
  createDate: string;
  sectionInfoHistoryID: number;
  sectionInfos: DomainSectionInfo[];
}

export interface DomainRefreshTokenResponse {
  accessToken?: string;
}

export type DomainRefundLogixType =
  | 'REFUND_LOGIX-TYPE_ALL'
  | 'REFUND_LOGIX-TYPE_BUYER_DIRECT'
  | 'REFUND_LOGIX-TYPE_SELLER_DIRECT';

export type DomainRefundReason =
  | 'REFUND_REASON_NOT_SATISFIED'
  | 'REFUND_REASON_BUYER_MISTAKE'
  | 'REFUND_REASON_WRONG_ITEM'
  | 'REFUND_REASON_WRONG_DELIVERY';

export interface DomainRejectRefundSellerRequest {
  orderItemIDs: number[];
}

export interface DomainRejectReturnProSellerRequest {
  orderItemIDs: number[];
}

export interface DomainRemoveBackgroundResponse {
  properties?: DomainClothesProperty[];
}

export interface DomainRemoveBackgroundV2Request {
  /** @example ["/image/1.jpg"] */
  imagePaths: string[];
  /** @example ["https://image.com/1.jpg"] */
  imageURLs: string[];
  isCropNeeded: boolean;
}

export interface DomainReplacePromotionInfosRequest {
  promotionInfos?: DomainPromotionInfoRequest[];
}

export interface DomainReplaceRecommInfosRequest {
  sectionInfos?: DomainSectionInfoRequest[];
}

export interface DomainReportItem {
  count?: number;
  createDate?: string;
  detail?: string;
  modifyDate?: string;
  nickname?: string;
  reason?: string;
  reportID?: number;
  reportType?: string;
  reportedID?: number;
  reportedUserID?: number;
  userID?: number;
}

export interface DomainReturnOrderByBuyerRequest {
  /** 메모 */
  address: string;
  /** 상세주소 */
  addressDetail: string;
  /** 수거해주세요, 직접 보낼게요 */
  method: DomainRefundLogixType;
  /** 수거 정보의 사람 이름 */
  name: string;
  orderItems: DomainReturnOrderItem[];
  /** 연락처 */
  phone: string;
  photos: string[];
  /** 우편번호 */
  zipCode: string;
}

export interface DomainReturnOrderInfoByBuyerResponse {
  /** 취소 금액 */
  cancelAmount?: number;
  /** 환불 수단 */
  payMethod?: DomainPayMethod;
  /** 환불 차감 쿠폰 금액 */
  refundDeductionCouponAmount?: number;
  /** 환불 차감 배송비 */
  refundDeductionLogixAmount?: number;
  /** 환불 차감 반품 배송비 */
  refundDeductionLogixReturnAmount?: number;
  /** 환불 차감 금액 */
  refundDeductionTotalAmount?: number;
  /** 반품 추가 주소 */
  returnAdditionalAddress?: string;
  /** 반품 주소 */
  returnAddress?: string;
  /** 환불 금액 */
  returnAmount?: number;
  /** 반품 받는 사람 연락처 */
  returnPhone?: string;
  /** 반품 받는 사람 */
  returnRecipient?: string;
  /** 반품 우편번호s */
  returnZipCode?: string;
  /** 반품 가능 여부 */
  returnable?: boolean;
}

export interface DomainReturnOrderItem {
  orderItemID: number;
  reasonDetails: string;
  reasonType: DomainRefundReason;
}

export interface DomainReturnablePurchaseOrderItemsResponse {
  orderItems?: DomainOrderItemDetailDto[];
}

export interface DomainReviewUserResponse {
  /**
   * 리뷰를 하는/받는 유저 닉네임
   * @example "GiraffeWithCode"
   */
  nickname: string;
  /**
   * 리뷰를 하는/받는 유저 프로필 이미지 URL
   * @example "https://s3.ap-northeast-2.amazonaws.com/brandi-static/brandi_profile_image/162615/162615_2019-11-27_15:00:00.000000.png"
   */
  profileImageURL?: string;
  /**
   * 리뷰를 하는/받는 유저 ID
   * @example 162615
   */
  userID: number;
}

export interface DomainSearchBrandResponse {
  /** @example "THE NORTH FACE" */
  brandName: string;
}

export interface DomainSearchNicknameResponse {
  /** @example true */
  hasNext?: boolean;
  users?: DomainSearchNicknameUsers[];
}

export interface DomainSearchNicknameUsers {
  /**
   * 배경 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  backgroundImageURL?: string;
  /**
   * 조회한 유저 기준 팔로우 여부
   * @example true
   */
  isFollowing: boolean;
  /**
   * 해당 유저가 파워셀러인지 여부
   * @example false
   */
  isProSeller: boolean;
  /**
   * 닉네임
   * @example "hkja1"
   */
  nickname: string;
  /**
   * 프로필 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/calendars/thumbnails/45_1668079760550324052W_image.webp"
   */
  profileImageURL?: string;
  /**
   * 유저 아이디
   * @example 620687
   */
  userID: number;
}

export type DomainSearchType = 'LIKE' | 'EQUAL';

export interface DomainSeasonIndex {
  /** @example true */
  isFall: boolean;
  /** @example true */
  isSpring: boolean;
  /** @example true */
  isSummer: boolean;
  /** @example true */
  isWinter: boolean;
}

export interface DomainSectionInfo {
  display: DomainDisplay;
  /** @example 1 */
  order: number;
  /**
   * api path
   * @example "/market-items"
   */
  path: string;
  query: DomainQuery;
  /**
   * 프론트에서 사용하는 키 (unix second)
   * @example 1687324366
   */
  sectionKey: number;
  sectionType:
    | 'MARKET_ITEM_FILTER'
    | 'MARKET_ITEM_RECENTLY_VIEWED'
    | 'MARKET_ITEM_SPECIFIC_USER'
    | 'MARKET_ITEM_SEARCH';
}

export interface DomainSectionInfoRequest {
  display: DomainDisplayRequest;
  /** @example 1 */
  order: number;
  query: DomainQueryRequest;
  /**
   * 프론트에서 사용하는 키 (unix second)
   * @example 1687324366
   */
  sectionKey: number;
  sectionType:
    | 'MARKET_ITEM_FILTER'
    | 'MARKET_ITEM_RECENTLY_VIEWED'
    | 'MARKET_ITEM_SPECIFIC_USER'
    | 'MARKET_ITEM_SEARCH';
}

export interface DomainSendMobileVerificationCodeRequest {
  /**
   * 국가 전화번호
   * @example "+82"
   */
  dialingCode: string;
  /**
   * 휴대폰 번호
   * @example "01012345678"
   */
  mobile: string;
  /** @example "asjklfjekljke" */
  recaptcha: string;
}

export interface DomainSendMobileVerificationCodeResponse {
  /** 인증코드 만료 시간 */
  expiredAt: number;
}

export interface DomainServiceProperty {
  categoryIDs?: number[];
  colorIDs?: number[];
  materialIDs?: number[];
  patternIDs?: number[];
}

export interface DomainSettlementItem {
  /** 판매자 예금주명 */
  accountHolder: string;
  /** 판매자 계좌번호 */
  accountNumber: string;
  /** TODO Deprecated: 5.2.0 LegacyAmount */
  amount: number;
  /** 요율이 제거된 판매 금액 (!!!json tag = amountWithoutPgFee) */
  amountWithoutPgFee: number;
  /** 판매자 은행 */
  bankName: string;
  /** 구매자가 결제한 금액 */
  buyerAmount: number;
  /** 쿠폰 할인 금액 */
  couponDiscountAmount: number;
  /** 구매확정일 */
  createDate: number;
  /** 정산일 */
  endDate?: number;
  marketItemThumbnail: string;
  marketItemTitle: string;
  modifyDate: number;
  /** 정산이 취소된다면 취소 사유 */
  reason?: string;
  /** 판매자가 정산받을 금액 */
  sellerAmount: number;
  /** 정산 아이디 */
  settlementID: number;
  /** 판매 상태 */
  status:
    | 'SETTLEMENT_STATUS_UNAUDITED'
    | 'SETTLEMENT_STATUS_SCHEDULED'
    | 'SETTLEMENT_STATUS_COMPLETED'
    | 'SETTLEMENT_STATUS_HOLD';
  /** 거래 아이디 */
  txID: number;
  /** 판매자 아이디 */
  userID: number;
}

export interface DomainSignUpGuestRequest {
  /** @example "1.0" */
  appVersion?: string;
  /** @example "Mobile" */
  device?: string;
  /** Username으로 등록 */
  deviceID?: string;
  language?: string;
  nation?: string;
  onboardingItemAttachID?: number;
  /** @example "OSX" */
  os?: string;
  /** @example "1.0" */
  osVersion?: string;
  /** @example "UTC|KST" */
  timezoneStr?: string;
}

export interface DomainSignUpGuestResponse {
  accessToken?: string;
  refreshToken?: string;
  success?: boolean;
  userID?: number;
}

export interface DomainSignUpNormalRequest {
  /** @example "2000-01-01" */
  dateOfBirth: string;
  email: string;
  fcmToken: string;
  /** @example "FEMALE, MALE, NONBINARY, RATHERNOTSAY" */
  gender: string;
  language: string;
  nation: string;
  nickname: string;
  onboardingItemAttachID?: number;
  password: string;
  /**
   * 기타 정보들
   * @example "ROLE_USER, ROLE_OWNER, ROLE_MANAGER"
   */
  role: string;
}

export interface DomainSignUpProSellerRequest {
  /** 예금주 */
  accountHolder: string;
  /** 계좌번호 */
  accountNumber: string;
  /** 은행명 */
  bankName: string;
  /** 사업자 주소 */
  businessAddress: string;
  /** 사업자 연락처 */
  businessContact: string;
  /** 사업자 이름 */
  businessName?: string;
  /**
   * 임의의 값
   * @example "2000-01-01"
   */
  dateOfBirth: string;
  email: string;
  /**
   * 중요하지 않은 정보들
   * @example "FEMALE, MALE, NONBINARY, RATHERNOTSAY"
   */
  gender: string;
  /** CS 담당 연락처 */
  inquiryContact: string;
  /** 채팅 답변 가능시간 */
  inquiryPossibleTime: string;
  /** 임의의 값 */
  language: string;
  /** 지역별 배송비 */
  logixPriceByArea?: boolean;
  /** 임의의 값 */
  nation: string;
  /** 샵이름 */
  nickname: string;
  /**
   * `MARKET-ITEM_LOGIX-TYPE_PREPAID-SHIPPING-FEE` 현재 api 에서 허용안함<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_COLLECT-ON-DELIVERY` 현재 api 에서 허용안함<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_FREE` 배송비 무료<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_PAY` 배송비 유료 (logixPrice 필수)<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_FREE-ON-AMOUNT` 배송 (order_logix_type_free_on_amount 필수)<br/>
   * 		`MARKET-ITEM_LOGIX-TYPE_PAY-ON-QUANTITY` 배송 (order_logix_type_pay_on_quantity 필수)<br/>
   */
  orderLogixType: DomainLogixType;
  /** MARKET-ITEM_LOGIX-TYPE_FREE-ON_AMOUNT 선택시 무료 배송이 되는 금액, 입력시 최소 1이상 */
  orderLogixTypeFreeOnAmount?: number;
  /** MARKET-ITEM_LOGIX-TYPE_PAY-ON-QUANTITY 선택시 지정된 갯수마다 배송비 부과, 입력시 최소 1 이상 */
  orderLogixTypePayOnQuantity?: number;
  /** 주문 배송비 */
  orderShippingFee: DomainLogixPrice;
  password: string;
  /** 구매 수량 */
  purchaseQuantityLimit?: number;
  refundAddressInfo: DomainAddressInfoProSeller;
  /** 지정 택배사 이름 */
  refundCourierName?: string;
  /** 반품 방법 */
  refundLogixType: DomainRefundLogixType;
  /** 반품 정책 */
  refundPolicy: string;
  /** 반품 배송비 */
  refundShippingFee: DomainLogixPrice;
  /**
   * role이 다양해질 수 있음
   * @example "ROLE_OWNER"
   */
  role: string;
}

export interface DomainSignUpSNSRequest {
  accessToken: string;
  /** @example "2006-01-02" */
  dateOfBirth: string;
  /** @example "KAKAO, APPLE, GOOGLE, FACEBOOK" */
  division: string;
  email: string;
  fcmToken: string;
  /** @example "FEMALE, MALE, NONBINARY, RATHERNOTSAY" */
  gender: string;
  /**
   * (현재) APPLE 로그인의 경우에만 필요
   * @example "identity_token"
   */
  idToken?: string;
  /** @example "en" */
  language: string;
  /** @example "KR, US, JP, CN, etc..." */
  nation: string;
  nickname: string;
  /** @example 1 */
  onboardingItemAttachID?: number;
  /**
   * 기타 정보들
   * @example "ROLE_USER, ROLE_OWNER, ROLE_MANAGER"
   */
  role: string;
}

export interface DomainSize {
  categoryGroup: string;
  eu: string;
  genderWear: string;
  /** International */
  it: string;
  kr: string;
  sizeID: number;
  uk: string;
  us: string;
}

export type DomainSortOrder = 'asc' | 'desc';

export interface DomainTopCategory {
  id?: number;
  middleCategory?: DomainMiddleCategory[];
  name?: string;
}

export interface DomainTranslation {
  code: string;
  en: string;
  es: string;
  fr: string;
  ko: string;
  ru: string;
}

export interface DomainUnbanUserRequest {
  bannedUserID: number;
}

export interface DomainUpdateClothesV2Request {
  /** frontend에서 brand 유지 */
  brand?: number;
  clothesID?: number;
  isArchived?: boolean;
  isFall?: boolean;
  isSpring?: boolean;
  isSummer?: boolean;
  isWinter?: boolean;
  memo?: string;
  price?: number;
  purchaseDate?: string;
  shopLink?: string;
  size?: string;
}

export interface DomainUpdateDailylookRequest {
  /**
   * 비율(1:1, 3:4)
   * @example "1/1"
   */
  aspectRatio?: string;
  /**
   * 캘린더 날짜
   * @example "2022-10-10"
   */
  calendarDate?: string;
  /**
   * 캘린더 날씨 최고 온도
   * @example 19
   */
  calendarTemperatureMax?: number;
  /**
   * 캘린더 날씨 최저 온도
   * @example 10
   */
  calendarTemperatureMin?: number;
  /**
   * 캘린더 날씨 코드
   * @example "WEATHER_SNOW"
   */
  calendarWeatherCode?: string;
  /** 데일리룩 컨텐츠 리스트 */
  contents?: DomainDailylookContentRequest[];
  /**
   * TODO 버그로 인해 임시로 RemoveImages를 쓰도록 합니다.
   * @example [123,124,125]
   */
  deleteImages?: number[];
  /**
   * 설명
   * @example "행복한 여행"
   */
  description?: string;
  /** 데일리룩 추가 이미지 리스트 */
  insertImages?: DomainDailylookImageRequest[];
  /**
   * 공개 여부
   * @example false
   */
  isPrivate?: boolean;
  /**
   * 삭제할 데일리룩 이미지 아이디 리스트
   * @example [123,124,125]
   */
  removeImages?: number[];
  /** 데일리룩 변경 이미지 리스트 */
  updateImages?: DomainDailylookImageRequest[];
}

export interface DomainUpdateIdeaRequest {
  /**
   * 비율(1:1, 3:4)
   * @example "1/1"
   */
  aspectRatio?: string;
  /**
   * 속성 코드 리스트
   * @example ["OUTFIT_SEASON_SUMMER"]
   */
  attributeCodes?: string[];
  /** 아이디어 컨텐츠 리스트 */
  contents?: DomainIdeaContentRequest[];
  /**
   * TODO 버그로 인해 임시로 RemoveImages를 쓰도록 합니다.
   * @example [123,124,125]
   */
  deleteImages?: number[];
  /**
   * 설명
   * @example "행복한 여행"
   */
  description?: string;
  /**
   * 태그 리스트
   * @example ["6월 여행"," 여름 바캉스"]
   */
  ideaTags?: string[];
  /** 아이디어 추가 이미지 리스트 */
  insertImages?: DomainIdeaImageRequest[];
  /**
   * 공개 여부
   * @example false
   */
  isPrivate?: boolean;
  /**
   * 언어
   * @example "en"
   */
  language?: string;
  /**
   * 삭제할 데일리룩 이미지 아이디 리스트
   * @example [123,124,125]
   */
  removeImages?: number[];
  /** 아이디어 변경 이미지 리스트 */
  updateImages?: DomainIdeaImageRequest[];
}

export interface DomainUpdateIdeasRequest {
  /**
   * 속성 코드 리스트
   * @example ["OUTFIT_SEASON_WINTER"]
   */
  attributeCodes?: string[];
  /**
   * 아이디어 아이디 리스트
   * @example [1]
   */
  ideaIDs: number[];
  /**
   * 비공개 여부
   * @example true
   */
  isPrivate?: boolean;
  /**
   * 속성 코드 서브 도메인
   * @example "SEASON"
   */
  subDomain?: 'STYLE' | 'OCCASION' | 'SEASON';
}

export interface DomainUpdateMarketItemImageRequest {
  /**
   * 중고 아이템 수정 시 수정할 이미지 ID
   * @example 6251
   */
  imageID: number;
  /**
   * 대표이미지 여부
   * @example false
   */
  isMain: boolean;
  /**
   * 순서 수정 시 순서 번호
   * @example 1
   */
  order: number;
  /** @example "http://naver.com" */
  thumbnailURL: string;
}

export interface DomainUpdateMarketItemRequest {
  /**
   * 중고 아이템 브랜드 이름
   * @example "ZARA"
   */
  brandName: string;
  /**
   * 중고 아이템 카테고리 ID
   * @example 25
   */
  categoryID: number;
  /**
   * 중고 아이템 색상 ID 리스트
   * @example [2,4,6]
   */
  colorIDs?: number[];
  /** 중고 아이템 추가 이미지 목록 */
  createImages?: DomainCreateMarketItemImageRequest[];
  /** 중고 아이템 삭제 이미지 목록 */
  deleteImages?: DomainDeleteMarketItemImageRequest[];
  /**
   * 중고 아이템 내용
   * @example "직거래는 강남역에서"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 100000000
   */
  discountPrice: number;
  /**
   * 중고 아이템 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear:
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_GIRL';
  /** 배송비 */
  logixPrice: DomainLogixPrice;
  /**
   * 배송 타입
   * @example "MARKET-ITEM_LOGIX-TYPE_PREPAID-SHIPPING-FEE,MARKET-ITEM_LOGIX-TYPE_COLLECT-ON-DELIVERY"
   */
  logixType: DomainLogixType;
  /**
   * 중고 아이템 가격
   * @example 150000000
   */
  price: number;
  /**
   * 중고 아이템 깨끗함 상태
   * @example "TBD"
   */
  quality?: string;
  /**
   * 중고 아이템 사이즈
   * @example "XS"
   */
  size?: string;
  /**
   * 중고 아이템 사이즈 ID
   * @example 1
   */
  sizeID?: number;
  /**
   * 중고 아이템 사이즈 지역
   * @example "us"
   */
  sizeRegion?: string;
  /**
   * 중고 아이템 제목
   * @example "그거 노스페이스가 아니라 사실 사우스 페이스였어요ㅠㅠ"
   */
  title: string;
  /** 중고 아이템 수정 이미지 목록 */
  updateImages?: DomainUpdateMarketItemImageRequest[];
}

export interface DomainUpdateMarketItemV2Request {
  /**
   * 중고 아이템 브랜드 이름
   * @example "ZARA"
   */
  brandName: string;
  /**
   * 중고 아이템 카테고리 ID
   * @example 25
   */
  categoryID: number;
  /**
   * 중고 아이템 색상 ID 리스트
   * @example [2,4,6]
   */
  colorIDs?: number[];
  /** 중고 아이템 추가 이미지 목록 */
  createImages?: DomainMarketItemImageRequest[];
  /** 중고 아이템 삭제 이미지 목록 */
  deleteImages?: DomainDeleteMarketItemImageRequest[];
  /**
   * 중고 아이템 내용
   * @example "직거래는 강남역에서"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 100000000
   */
  discountPrice: number;
  fabrics?: string[];
  /**
   * 중고 아이템 성별
   * @example "MARKET-ITEM_GENDERWEAR_MEN"
   */
  genderWear:
    | 'MARKET-ITEM_GENDERWEAR_MEN'
    | 'MARKET-ITEM_GENDERWEAR_WOMEN'
    | 'MARKET-ITEM_GENDERWEAR_BOY'
    | 'MARKET-ITEM_GENDERWEAR_GIRL';
  itemOrigin?: string;
  keywords: string[];
  logixID?: number;
  /** 배송비 */
  logixPrice: DomainLogixPrice;
  /**
   * 배송 타입
   * @example "MARKET-ITEM_LOGIX-TYPE_PREPAID-SHIPPING-FEE,MARKET-ITEM_LOGIX-TYPE_COLLECT-ON-DELIVERY"
   */
  logixType: string;
  /** @example 1 */
  materialID?: number;
  neck?: string;
  /** @example 1 */
  patternID?: number;
  /**
   * 중고 아이템 가격
   * @example 150000000
   */
  price: number;
  /**
   * 중고 아이템 깨끗함 상태
   * @example "TBD"
   */
  quality?: string;
  raglan?: DomainMarketItemRaglanType[];
  shoulderPad?: DomainMarketItemShoulderPadType[];
  /**
   * 중고 아이템 사이즈
   * @example "XS"
   */
  size?: string;
  /**
   * 중고 아이템 사이즈 ID
   * @example 1
   */
  sizeID?: number;
  /**
   * 중고 아이템 사이즈 지역
   * @example "us"
   */
  sizeRegion?: string;
  sleeveLength?: string;
  /**
   * 중고 아이템 제목
   * @example "그거 노스페이스가 아니라 사실 사우스 페이스였어요ㅠㅠ"
   */
  title: string;
  /** 중고 아이템 수정 이미지 목록 */
  updateImages?: DomainUpdateMarketItemImageRequest[];
  waistBanding?: DomainMarketItemWaistBandingType[];
}

export interface DomainUpdateOrderLogixBySellerRequest {
  orderItemLogixs?: DomainOrderItemLogix[];
}

export interface DomainUpdateProSellerLogixForLookoAIReponse {
  /** CS 담당 연락처 */
  afterServicePhoneNumber?: string;
  /** 택배사 */
  courierCompany?: string;
  /** 무료 배송 조건(배송료가 무료가 되는 주문금액) */
  freeOnAmount?: number;
  /** 공급사명 노출 여부 */
  isVisible?: boolean;
  /** 지역 별 배송비 사용 여부 */
  logixFeeByArea?: boolean;
  /** 배송정보 ID */
  logixID?: number;
  /** 공급사명(지점명) */
  logixName?: string;
  /** 배송비 */
  logixPrice?: DomainLogixPrice;
  /** 배송 타입 */
  logixType?: DomainLogixType;
  /** 프로 셀러 ID */
  proSellerID?: number;
  /** 최대 구매 수량 */
  purchaseQuantity?: number;
  /** 수거 방법 */
  refundLogixType?: DomainRefundLogixType;
  /** 반품 주소 */
  returnAddress?: string;
  /** 반품 상세 주소 */
  returnAddressDetail?: string;
  /** 반품 배송비 */
  returnFee?: number;
  /** 반품 이름 */
  returnName?: string;
  /** 반품 정책 */
  returnPolicy?: string;
  /** 반품 우편 번호 */
  returnZipCode?: string;
}

export interface DomainUpdateProSellerLogixForLookoAIRequest {
  /** CS 담당 연락처 */
  afterServicePhoneNumber?: string;
  /** 택배사 */
  courierCompany?: string;
  /** 무료 배송 조건(배송료가 무료가 되는 주문금액) */
  freeOnAmount?: number;
  /** 공급사명 노출 여부 */
  isVisible?: boolean;
  /** 지역 별 배송비 사용 여부 */
  logixFeeByArea?: boolean;
  /** 배송정보 ID */
  logixID?: number;
  /** 공급사명(지점명) */
  logixName?: string;
  /** 배송비 */
  logixPrice?: DomainLogixPrice;
  /** 배송 타입 */
  logixType?: DomainLogixType;
  /** 최대 구매 수량 */
  purchaseQuantity?: number;
  /** 수거 방법 */
  refundLogixType?: DomainRefundLogixType;
  /** 반품 주소 */
  returnAddress?: string;
  /** 반품 상세 주소 */
  returnAddressDetail?: string;
  /** 반품 배송비 */
  returnFee?: number;
  /** 반품 이름 */
  returnName?: string;
  /** 반품 정책 */
  returnPolicy?: string;
  /** 반품 우편 번호 */
  returnZipCode?: string;
}

export interface DomainUpdateWishlistRequest {
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 필터에 대한 설명
   * @example "1000~50000, ZARA, 남자, 옷파는야옹이, 파란색"
   */
  description?: string;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example ["MARKET-ITEM_GENDERWEAR_MEN","MARKET-ITEM_GENDERWEAR_WOMEN"]
   */
  genderWears?: DomainGenderWearType[];
  /** @example true */
  isNotification?: boolean;
  /**
   * 새로 생성된 아이템을 확인했는지 여부 (true: 확인함, false: 확인하지 않음)
   * @example true
   */
  isSeen?: boolean;
  /**
   * 빈 문자열은 안됨. 글자수 제한 없음
   * @example "스포츠 관심상품"
   */
  name?: string;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  /**
   * 1,000원 단위. 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example 40000
   */
  priceMax?: number;
  /**
   * 1,000원 단위. 필터를 사용하지 않는 경우 0이 아닌 null 로 받음
   * @example 1000
   */
  priceMin?: number;
  /**
   * 필터를 사용하지 않는 경우 빈 배열이 아닌 null 로 받음
   * @example [1,2,3]
   */
  sellerIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 빈 문자열이 아닌 null 로 받음
   * @example "나이키 집업"
   */
  textSearch?: string;
}

export interface DomainUpsertOfficialBrandRequest {
  brandID?: number;
  childBrands?: string[];
  logoImage: string;
  mainImage: string;
  nameEn: string;
  nameKr: string;
}

export interface DomainUpsertOfficialBrandTagsRequest {
  brandCategoryImage?: string;
  brandSectionTitle?: string;
  brandTagID?: number;
  isBrandCategoryVisible: boolean;
  name: string;
  officialBrandIDs: number[];
}

export interface DomainUserCouponItem {
  couponID: number;
  couponInfo: DomainCouponItem;
  createDate: string;
  /** 만기일 (0이면 만기일이 없음) */
  expirationDate: string;
  isExpired: boolean;
  isUsed: boolean;
  /** 사용 결제 아이디 (0) */
  txID: number;
  /** 사용일 (0이면 사용하지 않음) */
  usageDate: string;
  userCouponID: number;
  userID: number;
}

export interface DomainUserItem {
  bio?: string;
  birth?: string;
  clientConfig?: string;
  cloudUri?: string;
  commentNotifAgreed?: boolean;
  createDate?: string;
  currency?: string;
  delFlag?: boolean;
  dialingCode?: string;
  division?: string;
  email?: string;
  followNotifAgreed?: boolean;
  gender?: string;
  height?: number;
  id?: number;
  isBanned?: boolean;
  isGuest?: boolean;
  isPrivate?: boolean;
  isVerified?: boolean;
  language?: string;
  likeNotifAgreed?: boolean;
  link?: string;
  marketItemBookmarkNotifAgreed?: boolean;
  marketItemChattingPushNotifAgreed?: boolean;
  marketItemReviewNotifAgreed?: boolean;
  mobile?: string;
  name?: string;
  nation?: string;
  nickname?: string;
  role?: string;
  tempSenseLevel?: number;
  transactionPushNotifAgreed?: boolean;
  updateNotifAgreed?: boolean;
  updateNotifDate?: string;
  username?: string;
  weight?: number;
}

export interface DomainUserMarketItemResponse {
  /**
   * 해당 중고 물품에 북마크 한 수
   * @example 1
   */
  bookmarkCount: number;
  /**
   * 중고 옷 브랜드명
   * @example "SOUTH FACE"
   */
  brandName: string;
  /**
   * 중고 아이템 구매자 유저 ID
   * @example 22612346
   */
  buyerID?: number;
  /** @example 2626123 */
  clothesID?: number;
  /**
   * 중고 아이템 국가 코드
   * @example "KR"
   */
  countryCode: string;
  /**
   * 중고 아이템 생성일
   * @example 1668080178342
   */
  createDate: number;
  /**
   * TODO: 아래필드는 삭제 예정 (4.4.0) <-- 진짜 삭제하는지 확인
   * @example "KRW"
   */
  currency: string;
  /**
   * 중고 아이템 설명
   * @example "사실 2년 입었어유"
   */
  description: string;
  /**
   * 중고 아이템 할인 가격
   * @example 2000
   */
  discountPrice: number;
  /**
   * 중고 아이템 할인율
   * @example 30
   */
  discountRate: number;
  /** @example "MARKET-ITEM_FABRIC_COTTON" */
  fabric: string;
  /**
   * 조건부 무료 배송 조건
   * @example 1000
   */
  freeOnAmount: number;
  /** @example false */
  isBookmarked: boolean;
  /**
   * 중고 아이템 삭제 여부
   * @example false
   */
  isDeleted: boolean;
  /**
   * 프로셀러 여부
   * @example true
   */
  isProSeller: boolean;
  /**
   * 판매자의 탈퇴 여부
   * @example false
   */
  isSellerDeleted: boolean;
  /** 비슷한 상품 여부 */
  isSimilar?: boolean;
  /**
   * 지점명 노출 여부
   * @example true
   */
  isVisible: boolean;
  /**
   * 중고 아이템 검색 키워드
   * @example ["흰색","티셔츠","남성"]
   */
  keywords: string[];
  /**
   * 공급사명(지점명)
   * @example "공급사 없음"
   */
  logixName: string;
  logixPrice: DomainLogixPrice;
  logixType: DomainLogixType;
  /** @example 1246561453 */
  marketItemID: number;
  /**
   * 중고 아이템 수정일
   * @example 1668080178342
   */
  modifyDate: number;
  /**
   * 로그인한 유저가 해당 아이템에 리뷰를 한 경우, 해당 리뷰 ID (남기지 않았을 경우 false)
   * @example 1245125
   */
  myReviewID?: number;
  /**
   * 중고 아이템 가격
   * @example 3000
   */
  price: number;
  /**
   * 중고 아이템의 상태 (깨끗함, 더러움 등)
   * @example "MARKET-ITEM_QUALITY_NEW-WITH-TAG"
   */
  quality:
    | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
    | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
    | 'MARKET-ITEM_QUALITY_GOOD'
    | 'MARKET-ITEM_QUALITY_LITTLE-USE'
    | 'MARKET-ITEM_QUALITY_MANY-USE'
    | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE';
  /**
   * 중고 옷 사이즈
   * @example "FREE"
   */
  size: string;
  /** 중고 아이템 판매 상태 */
  status: DomainMarketItemStatus;
  /**
   * 중고 아이템 이미지 URL
   * @example "https://d3ku6i8uhaesym.cloudfront.net/fashionItems/images/fendi/FY0936A9RKF10WT_01_1657595204168195058_bgr.webp"
   */
  thumbnailURL: string;
  /**
   * 중고 아이템 제목
   * @example "새것 같은 노스페이스 패딩 팔아유"
   */
  title: string;
  /**
   * 중고 아이템 판매자 유저 ID
   * @example 22612346
   */
  userID: number;
  /** 와우 할인가 */
  wowDiscountAmount?: number;
}

export interface DomainValidateCouponRecipientResponse {
  valid?: boolean;
}

export interface DomainVerifyEmailVerificationCodeRequest {
  /**
   * 인증코드
   * @example "123456"
   */
  verificationCode: string;
}

export interface DomainVerifyMobileVerificationCodeRequest {
  /**
   * 인증코드
   * @example "123456"
   */
  verificationCode: string;
}

export interface DomainWishlistDTO {
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  categoryIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  colorIDs?: number[];
  /**
   * 필터에 대한 설명
   * @example "1000~50000, ZARA, 남자, 옷파는야옹이, 파란색"
   */
  description?: string;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example ["MARKET-ITEM_GENDERWEAR_MEN","MARKET-ITEM_GENDERWEAR_WOMEN"]
   */
  genderWears?: DomainGenderWearType[];
  /**
   * 알람 여부
   * @example true
   */
  isNotification: boolean;
  /**
   * 새로 생성된 아이템을 확인했는지 여부 (true: 확인함, false: 확인하지 않음)
   * @example true
   */
  isSeen: boolean;
  /**
   * 빈 문자열은 안됨. 글자수 제한 없음
   * @example "스포츠 관심상품"
   */
  name: string;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  officialBrandIDs?: number[];
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 null 로 반환함.
   * @example 40000
   */
  priceMax?: number;
  /**
   * 1,000원 단위 필터를 사용하지 않는 경우 null 로 반환함.
   * @example 1000
   */
  priceMin?: number;
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example [1,2,3]
   */
  sellerIDs?: number[];
  /**
   * 필터를 사용하지 않는 경우 null 로 반환함.
   * @example "나이키 집업"
   */
  textSearch?: string;
  /** @example 1 */
  userID: number;
  /** @example 1 */
  wishlistID: number;
}

export interface ErrorsErrorResponse {
  code?: string;
  message?: string;
}

export namespace MarketItems {
  /**
   * @description 중고 리스트 조회
   * @tags Markets
   * @name MarketItemsList
   * @summary ListMarketItems
   * @request GET:/market-items
   * @secure
   * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
   */
  export namespace MarketItemsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 포함할 브랜드
       * @example ["NIKE","ADIDAS"]
       */
      brandNames?: string[];
      /** @example 1 */
      buyerID?: number;
      /**
       * 포함할 카테고리 ID
       * @example [1,2,3]
       */
      categoryIDs?: number[];
      /**
       * 포함할 컬러 ID
       * @example [1,2,3]
       */
      colorIDs?: number[];
      /**
       * 최대 할인율
       * @example 50
       */
      discountRateMax?: number;
      /**
       * 최소 할인율 (최소 할인율 0 이상)
       * @example 10
       */
      discountRateMin?: number;
      /**
       * 포함할 성별
       * @example "MARKET-ITEM_GENDERWEAR_MEN"
       */
      genderWear?:
        | 'MARKET-ITEM_GENDERWEAR_WOMEN'
        | 'MARKET-ITEM_GENDERWEAR_MEN'
        | 'MARKET-ITEM_GENDERWEAR_GIRL'
        | 'MARKET-ITEM_GENDERWEAR_BOY'
        | 'MARKET-ITEM_GENDERWEAR_UNISEX'
        | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX';
      /**
       * 포함할 성별
       * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
       */
      genderWears?: (
        | 'MARKET-ITEM_GENDERWEAR_WOMEN'
        | 'MARKET-ITEM_GENDERWEAR_MEN'
        | 'MARKET-ITEM_GENDERWEAR_GIRL'
        | 'MARKET-ITEM_GENDERWEAR_BOY'
        | 'MARKET-ITEM_GENDERWEAR_UNISEX'
        | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX'
      )[];
      /**
       * 무료배송 여부
       * @example true
       */
      isFreeShipping?: boolean;
      /** @example 30 */
      limit: number;
      marketItemIDs?: number[];
      /** 포함할 공식 브랜드 */
      officialBrandIDs?: number[];
      /** @example 0 */
      offset: number;
      omitNoBrand?: boolean;
      orderField?: 'marketItemID' | 'discountPrice' | 'discountRate' | 'createDate' | 'modifyDate' | '_score';
      /**
       * 최대 가격
       * @example 100000
       */
      priceMax?: number;
      /**
       * 최소 가격 (최소 가격 0 이상)
       * @example 10000
       */
      priceMin?: number;
      /**
       * 포함할 상품 상태
       * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
       */
      qualities?: (
        | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
        | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
        | 'MARKET-ITEM_QUALITY_GOOD'
        | 'MARKET-ITEM_QUALITY_LITTLE-USE'
        | 'MARKET-ITEM_QUALITY_MANY-USE'
        | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
      )[];
      /** @example 1668080178342 */
      searchTimestamp: number;
      /** @example 1 */
      sellerID?: number;
      /** @example [1,2,3] */
      sellerIDs?: number[];
      /**
       * 포함할 사이즈
       * @example [1,2,3]
       */
      sizeIDs?: number[];
      sortOrder?: 'asc' | 'desc';
      /**
       * 포함할 판매 상태
       * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
       */
      statuses?: (
        | 'MARKET-ITEM_STATUS_SOLD'
        | 'MARKET-ITEM_STATUS_PROCESSING'
        | 'MARKET-ITEM_STATUS_FOR-SALE'
        | 'MARKET-ITEM_STATUS_STOP-SALE'
      )[];
      /** @example "흰색 티셔츠" */
      textSearch?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemsResponse;
  }
  /**
   * @description 중고 (단건) 생성
   * @tags Markets
   * @name MarketItemsCreate
   * @summary CreateMarketItem
   * @request POST:/market-items
   * @secure
   * @response `204` `void` No Content
   */
  export namespace MarketItemsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainCreateMarketItemRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * @description ### 채팅방에 필요한 데이터들을 조회합니다. : https://github.com/looko-corp/acloset-api/issues/530 #### 해당 API는 채팅방 리스트를 보여줄 때 사용자의 닉네임, 이미지 또는 상품의 이미지등을 보여주기 위해서 부르는 API 입니다. 샌드버드에서 관리하는 channel_url로 chatroomID를 query filter 하기를 기대하고 있습니다. --- ### QueryParam - chatroomID : 샌드버드 ID를 요청받으면 해당 값을 기준으로 필터링 (group_channel의 channel_url값을 기대) (collectionFormat": "multi") - marketItemID : 중고 ID를 요청받으면 해당 값을 기준으로 필터링 ### Authorization 헤더에 서비스 토큰을 넣어주시면 해당 유저를 기준으로 채팅방리스트를 전부 조회합니다. ### 만약 서비스 토큰이 유효하지 않은 경우 아래와 같은 에러를 내뱉습니다. - ### `[401] {AUTH_UNAUTHORIZED} - 인증에 실패하였습니다.}` Swagger 문서작성 (2022-01-11)
   * @tags Markets
   * @name ChatroomsList
   * @summary ListMarketItemChatrooms
   * @request GET:/market-items/chatrooms
   * @secure
   * @response `200` `DomainListMarketItemChatroomsResponse` 채팅방 리스트 응답 값
   */
  export namespace ChatroomsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 채팅방 ID (Sendbird 한정 : channel_url)
       * @example ["sendbird_group_channel_25108471_a1bc35f5f0d237207bc1rd343562c878fc2fd426"]
       */
      chatroomID?: string[];
      /**
       * 중고 아이템 ID
       * @example 123883
       */
      marketItemID?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemChatroomsResponse;
  }
  /**
   * @description 중고 채팅방 삭제 (marketItemID or chatroomIDs 값중 하나는 필수 값)
   * @tags Markets
   * @name ChatroomsDelete
   * @summary DeleteMarketItemChatrooms
   * @request DELETE:/market-items/chatrooms
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ChatroomsDelete {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainDeleteMarketItemChatroomsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * @description 구매자의 리뷰 거절
   * @tags Markets
   * @name ClaimPurchaseCreate
   * @summary ClaimPurchase
   * @request POST:/market-items/claim-purchase
   * @secure
   * @response `204` `void` No Content
   */
  export namespace ClaimPurchaseCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainClaimPurchaseRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * @description 중고 아이템 판매 종료
   * @tags Markets
   * @name CloseCreate
   * @summary CloseMarketItem
   * @request POST:/market-items/close
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ErrorsErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: MARKET_ITEM_UPDATION_NOT_ALLOWED
   * @response `404` `ErrorsErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
   */
  export namespace CloseCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = DomainCloseMarketItemRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags Markets
   * @name FilterList
   * @summary ListFilterMarketItemCounts
   * @request GET:/market-items/filter
   * @secure
   * @response `200` `DomainListFilterMarketItemCountsResponse` 주간 마켓아이템 갯수
   */
  export namespace FilterList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 포함할 카테고리 ID
       * @example [1,2,3]
       */
      categoryIDs?: number[];
      /**
       * 포함할 컬러 ID
       * @example [1,2,3]
       */
      colorIDs?: number[];
      /** 브랜드는 종류가 너무 많아서 특정 Group by 하면 로드가 부담되어 현재 페이지 브랜드만 Group by */
      currentPageOfficialBrandIDs?: number[];
      /**
       * 최대 할인율
       * @example 50
       */
      discountPriceMax?: number;
      /**
       * 최소 할인율 (최소 할인율 0 이상)
       * @example 10
       */
      discountPriceMin?: number;
      /**
       * 포함할 성별
       * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
       */
      genderWear?: (
        | 'MARKET-ITEM_GENDERWEAR_WOMEN'
        | 'MARKET-ITEM_GENDERWEAR_MEN'
        | 'MARKET-ITEM_GENDERWEAR_GIRL'
        | 'MARKET-ITEM_GENDERWEAR_BOY'
        | 'MARKET-ITEM_GENDERWEAR_UNISEX'
        | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX'
      )[];
      /** 포함할 공식 브랜드 */
      officialBrandIDs?: number[];
      /**
       * 포함할 판매자 ID
       * @example [1,2,3]
       */
      sellerIDs?: number[];
      /** @example "흰색 티셔츠" */
      textSearch?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListFilterMarketItemCountsResponse;
  }
  /**
   * @description 프로모션 정보 리스트 조회
   * @tags Markets
   * @name PromotionInfosList
   * @summary ListPromotionInfos 프로모션 정보 리스트 조회
   * @request GET:/market-items/promotion-infos
   * @secure
   * @response `200` `DomainListPromotionInfosResponse` 프로모션 정보 리스트 응답 값
   */
  export namespace PromotionInfosList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListPromotionInfosResponse;
  }
  /**
   * @description 조회한 결과로 나온 마켓아이템의 판매자가 내가 차단한 사용자라면, 해당 마켓아이템은 제외합니다. 추가적으로 hasNext 필드를 추가하여, 다음 페이지가 있는지 없는지를 알려줍니다. 최대 150개 까지만 조회할 수 있습니다. 최근 본 마켓아이템 리스트 조회, 작동확인 (없으면 빈 리스트)
   * @tags Markets
   * @name RecentlyViewedList
   * @summary ListRecentlyViewedMarketItems
   * @request GET:/market-items/recently-viewed
   * @secure
   * @response `200` `DomainListRecentlyViewedMarketItemsResponse` 최근 본 마켓아이템 응답값
   */
  export namespace RecentlyViewedList {
    export type RequestParams = {};
    export type RequestQuery = {
      /**
       * 최근 본 중고 아이템 목록의 개수
       * @example 10
       */
      limit?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListRecentlyViewedMarketItemsResponse;
  }
  /**
   * @description 추천 정보 리스트 조회
   * @tags Markets
   * @name RecommendationInfosList
   * @summary ListRecommInfos 추천 정보 리스트 조회
   * @request GET:/market-items/recommendation-infos
   * @secure
   * @response `200` `DomainListRecommInfosResponse` 중고 리스트 응답 값
   */
  export namespace RecommendationInfosList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListRecommInfosResponse;
  }
  /**
   * No description
   * @tags Markets
   * @name WeeklyCountList
   * @summary CountWeeklyMarketItem
   * @request GET:/market-items/weekly-count
   * @secure
   * @response `200` `DomainCountWeeklyMarketItemResponse` 주간 마켓아이템 갯수
   */
  export namespace WeeklyCountList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCountWeeklyMarketItemResponse;
  }
  /**
   * @description 중고 단건 조회, 작동확인
   * @tags Markets
   * @name MarketItemsDetail
   * @summary GetMarketItem
   * @request GET:/market-items/{marketItemID}
   * @secure
   * @response `200` `DomainGetMarketItemResponse` 중고 단건 응답값
   */
  export namespace MarketItemsDetail {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetMarketItemResponse;
  }
  /**
   * @description 중고(단건) 갱신
   * @tags Markets
   * @name MarketItemsUpdate
   * @summary UpdateMarketItem
   * @request PUT:/market-items/{marketItemID}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ErrorsErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: MARKET_ITEM_UPDATION_NOT_ALLOWED
   * @response `404` `ErrorsErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
   */
  export namespace MarketItemsUpdate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 2515
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainUpdateMarketItemRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * @description 중고(단건) 삭제
   * @tags Markets
   * @name MarketItemsDelete
   * @summary DeleteMarketItem
   * @request DELETE:/market-items/{marketItemID}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ErrorsErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: MARKET_ITEM_DELETION_NOT_ALLOWED
   * @response `404` `ErrorsErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
   */
  export namespace MarketItemsDelete {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 26124
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * @description 중고(단건) 갱신
   * @tags Markets
   * @name MarketItemsPartialUpdate
   * @summary PatchMarketItem
   * @request PATCH:/market-items/{marketItemID}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ErrorsErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: MARKET_ITEM_UPDATION_NOT_ALLOWED
   * @response `404` `ErrorsErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
   */
  export namespace MarketItemsPartialUpdate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 2515
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchMarketItemRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * @description 중고 마켓아이템 판매중변경
   * @tags Markets
   * @name AsProcessingPartialUpdate
   * @summary PatchMarketItemAsProcessing
   * @request PATCH:/market-items/{marketItemID}/as-processing
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ErrorsErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: TX_DUPLICATED<br />마켓 아이템이 판매중이 아닐때 Code: MARKET_ITEM_NOT_FOR_SALE
   * @response `404` `ErrorsErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
   */
  export namespace AsProcessingPartialUpdate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 2515
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * @description 중고 마켓아이템 판매중으로 변경
   * @tags Markets
   * @name AsSellingPartialUpdate
   * @summary PatchMarketItemAsSelling
   * @request PATCH:/market-items/{marketItemID}/as-selling
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ErrorsErrorResponse` 마켓 아이템 상태가 Processing가 아닐때 Code: MARKET_ITEM_NOT_PROCESSING
   * @response `404` `ErrorsErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
   */
  export namespace AsSellingPartialUpdate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 2515
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainPatchMarketItemAsSellingRequest;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * @description 중고 북마크 생성
   * @tags Markets
   * @name BookmarksCreate
   * @summary CreateMarketItemBookmark
   * @request POST:/market-items/{marketItemID}/bookmarks
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BookmarksCreate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 26124
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * @description 중고 북마크 삭제
   * @tags Markets
   * @name BookmarksDelete
   * @summary DeleteMarketItemBookmark
   * @request DELETE:/market-items/{marketItemID}/bookmarks
   * @secure
   * @response `204` `void` No Content
   */
  export namespace BookmarksDelete {
    export type RequestParams = {
      /** 중고 ID */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * @description 판매완료, 판매중지, 거래중의 아이템과 비슷한 아이템을 추천
   * @tags Markets
   * @name CartSimilarItemsDetail
   * @summary 장바구니에서 비슷한 상품 추천
   * @request GET:/market-items/{marketItemID}/cart-similar-items
   * @secure
   * @response `200` `DomainListCartSimilarMarketItemsResponse` 중고 리스트 응답 값
   */
  export namespace CartSimilarItemsDetail {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {
      /** @example 30 */
      limit: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListCartSimilarMarketItemsResponse;
  }
  /**
   * @description 중고 채팅방 생성, mSwagger 문서작성 (2023-01-19)
   * @tags Markets
   * @name ChatroomsCreate
   * @summary CreateMarketItemChatroo
   * @request POST:/market-items/{marketItemID}/chatrooms
   * @secure
   * @response `200` `DomainCreateMarketItemChatroomResponse` 중고 채팅방 생성 응답 값
   */
  export namespace ChatroomsCreate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 26124
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateMarketItemChatroomRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateMarketItemChatroomResponse;
  }
  /**
   * No description
   * @tags Markets
   * @name EditableDetail
   * @summary GetMarketItemEditable
   * @request GET:/market-items/{marketItemID}/editable
   * @secure
   * @response `200` `DomainGetMarketItemEditableResponse` 삭제 수정 가능 여부 응답값
   */
  export namespace EditableDetail {
    export type RequestParams = {
      marketItemId: string;
    };
    export type RequestQuery = {
      marketItemID?: number;
      /** @example "EDIT,DELETE,CLOSE" */
      type?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetMarketItemEditableResponse;
  }
  /**
   * @description 중고 리뷰 생성
   * @tags Markets
   * @name ReviewsCreate
   * @summary CreateMarketItemReview
   * @request POST:/market-items/{marketItemID}/reviews
   * @secure
   * @response `200` `DomainCreateMarketItemReviewResponse` 중고 리뷰 생성 응답값
   */
  export namespace ReviewsCreate {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 26124
       */
      marketItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = DomainCreateMarketItemReviewRequest;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCreateMarketItemReviewResponse;
  }
  /**
   * @description 중고 리뷰 단건 조회, 작동확인
   * @tags Markets
   * @name ReviewsDetail
   * @summary GetMarketItemReview
   * @request GET:/market-items/{marketItemID}/reviews/{reviewID}
   * @secure
   * @response `200` `DomainGetMarketItemReviewResponse` 중고 리뷰 조회 반환 값
   */
  export namespace ReviewsDetail {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 26124
       */
      marketItemId: number;
      /**
       * 조회할 중고 리뷰 ID
       * @example 26124
       */
      reviewId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetMarketItemReviewResponse;
  }
  /**
   * @description 비슷한 상품 추천
   * @tags Markets
   * @name SellersOtherItemsDetail
   * @summary ListSellersOtherMarketItems
   * @request GET:/market-items/{marketItemID}/sellers-other-items
   * @secure
   * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
   */
  export namespace SellersOtherItemsDetail {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {
      /** @example 30 */
      limit: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemsResponse;
  }
  /**
   * @description 비슷한 상품 추천
   * @tags Markets
   * @name SimilarBrandItemsDetail
   * @summary ListSimilarBrandMarketItems
   * @request GET:/market-items/{marketItemID}/similar-brand-items
   * @secure
   * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
   */
  export namespace SimilarBrandItemsDetail {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {
      /** @example 30 */
      limit: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemsResponse;
  }
  /**
   * @description 소재 상품 모음전
   * @tags Markets
   * @name SimilarFabricItemsDetail
   * @summary ListSimilarFabricMarketItems
   * @request GET:/market-items/{marketItemID}/similar-fabric-items
   * @secure
   * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
   */
  export namespace SimilarFabricItemsDetail {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {
      /** @example 30 */
      limit: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemsResponse;
  }
  /**
   * @description 비슷한 상품 추천
   * @tags Markets
   * @name SimilarItemsDetail
   * @summary ListSimilarMarketItems
   * @request GET:/market-items/{marketItemID}/similar-items
   * @secure
   * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
   */
  export namespace SimilarItemsDetail {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {
      /** @example 30 */
      limit: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainListMarketItemsResponse;
  }
  /**
   * No description
   * @tags Orders
   * @name TransactionsDetail
   * @summary GetTxRecently
   * @request GET:/market-items/{marketItemID}/transactions
   * @secure
   * @response `200` `DomainGetOrderResponse` 거래 상세 조회 응답값
   * @response `404` `ErrorsErrorResponse` 거래가 존재하지 않을 경우 Code: TX_NOT_FOUND
   */
  export namespace TransactionsDetail {
    export type RequestParams = {
      /**
       * 중고 ID
       * @example 525
       */
      marketItemId: number;
    };
    export type RequestQuery = {
      /** @example 1 */
      buyerID?: number;
      /** @example 1 */
      sellerID?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetOrderResponse;
  }
}

export namespace Sendbird {
  /**
   * @description Swagger 문서작성 (2022-01-11) ### 특정 유저의 샌드버드 토큰을 조회합니다. : https://github.com/looko-corp/acloset-api/issues/511 --- ### Authorization 헤더에 서비스 토큰을 넣어주시면 샌드버드 토큰을 반환합니다. ### 만약 샌드버드 계정이 없는 경우에 토큰을 요청하면 아래와 같은 에러가 발생합니다. - ### `[404] {SENDBIRD_TOKEN_NOT_FOUND - 토큰을 찾을 수 없습니다.}`
   * @tags Sendbird
   * @name TokenList
   * @summary GetSendbirdToken
   * @request GET:/sendbird/token
   * @secure
   * @response `200` `DomainGetSendbirdTokenResponse` 토큰 요청 응답 값
   */
  export namespace TokenList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainGetSendbirdTokenResponse;
  }
  /**
   * @description ### 특정 유저의 샌드버드 토큰을 만듭니다 : https://github.com/looko-corp/acloset-api/issues/522 --- ### Authorization 헤더에 서비스 토큰을 요청하면 만들어 집니다. ### 만약 샌드버드 계정이 이미 있는 경우에는 아래와 같은 에러가 발생합니다. - ### `[409] {SENDBIRD_TOKEN_ALREADY_EXISTS - 이미 토큰이 존재합니다}` Swagger 문서작성 (2022-01-11)
   * @tags Sendbird
   * @name TokenCreate
   * @summary CreateSendbirdToken
   * @request POST:/sendbird/token
   * @secure
   * @response `204` `void` No Content
   */
  export namespace TokenCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = void;
  }
  /**
   * @description Swagger 문서작성 (2022-01-11) ### 특정유저의 샌드버드 채팅에서 안읽은 메세지수 조회 : https://github.com/looko-corp/acloset-api/issues/528 --- ### Authorization 헤더에 서비스 토큰을 요청하면 만들어 집니다. ### 만약 샌드버드 계정이 없는 경우에 토큰을 요청하면 아래와 같은 에러가 발생합니다. - ### `[404] {SENDBIRD_TOKEN_NOT_FOUND - 토큰을 찾을 수 없습니다.}`
   * @tags Sendbird
   * @name UnreadMessageCountList
   * @summary CountSendbirdUnreadMessage
   * @request GET:/sendbird/unread-message-count
   * @secure
   * @response `200` `DomainCountSendbirdUnreadMessageResponse` 안읽은 메세지 개수 응답 값
   */
  export namespace UnreadMessageCountList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DomainCountSendbirdUnreadMessageResponse;
  }
}

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title No title
 * @contact
 */
export class SwaggerApi<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  marketItems = {
    /**
     * @description 중고 리스트 조회
     *
     * @tags Markets
     * @name MarketItemsList
     * @summary ListMarketItems
     * @request GET:/market-items
     * @secure
     * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
     */
    marketItemsList: (
      query: {
        /**
         * 포함할 브랜드
         * @example ["NIKE","ADIDAS"]
         */
        brandNames?: string[];
        /** @example 1 */
        buyerID?: number;
        /**
         * 포함할 카테고리 ID
         * @example [1,2,3]
         */
        categoryIDs?: number[];
        /**
         * 포함할 컬러 ID
         * @example [1,2,3]
         */
        colorIDs?: number[];
        /**
         * 최대 할인율
         * @example 50
         */
        discountRateMax?: number;
        /**
         * 최소 할인율 (최소 할인율 0 이상)
         * @example 10
         */
        discountRateMin?: number;
        /**
         * 포함할 성별
         * @example "MARKET-ITEM_GENDERWEAR_MEN"
         */
        genderWear?:
          | 'MARKET-ITEM_GENDERWEAR_WOMEN'
          | 'MARKET-ITEM_GENDERWEAR_MEN'
          | 'MARKET-ITEM_GENDERWEAR_GIRL'
          | 'MARKET-ITEM_GENDERWEAR_BOY'
          | 'MARKET-ITEM_GENDERWEAR_UNISEX'
          | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX';
        /**
         * 포함할 성별
         * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
         */
        genderWears?: (
          | 'MARKET-ITEM_GENDERWEAR_WOMEN'
          | 'MARKET-ITEM_GENDERWEAR_MEN'
          | 'MARKET-ITEM_GENDERWEAR_GIRL'
          | 'MARKET-ITEM_GENDERWEAR_BOY'
          | 'MARKET-ITEM_GENDERWEAR_UNISEX'
          | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX'
        )[];
        /**
         * 무료배송 여부
         * @example true
         */
        isFreeShipping?: boolean;
        /** @example 30 */
        limit: number;
        marketItemIDs?: number[];
        /** 포함할 공식 브랜드 */
        officialBrandIDs?: number[];
        /** @example 0 */
        offset: number;
        omitNoBrand?: boolean;
        orderField?: 'marketItemID' | 'discountPrice' | 'discountRate' | 'createDate' | 'modifyDate' | '_score';
        /**
         * 최대 가격
         * @example 100000
         */
        priceMax?: number;
        /**
         * 최소 가격 (최소 가격 0 이상)
         * @example 10000
         */
        priceMin?: number;
        /**
         * 포함할 상품 상태
         * @example ["MARKET-ITEM_QUALITY_NEW-WITH-TAG"]
         */
        qualities?: (
          | 'MARKET-ITEM_QUALITY_NEW-WITH-TAG'
          | 'MARKET-ITEM_QUALITY_NEW-WITHOUT-TAG'
          | 'MARKET-ITEM_QUALITY_GOOD'
          | 'MARKET-ITEM_QUALITY_LITTLE-USE'
          | 'MARKET-ITEM_QUALITY_MANY-USE'
          | 'MARKET-ITEM_QUALITY_PRO-SELLER-CARE'
        )[];
        /** @example 1668080178342 */
        searchTimestamp: number;
        /** @example 1 */
        sellerID?: number;
        /** @example [1,2,3] */
        sellerIDs?: number[];
        /**
         * 포함할 사이즈
         * @example [1,2,3]
         */
        sizeIDs?: number[];
        sortOrder?: 'asc' | 'desc';
        /**
         * 포함할 판매 상태
         * @example ["MARKET-ITEM_STATUS_FOR-SALE","MARKET-ITEM_STATUS_SOLD"]
         */
        statuses?: (
          | 'MARKET-ITEM_STATUS_SOLD'
          | 'MARKET-ITEM_STATUS_PROCESSING'
          | 'MARKET-ITEM_STATUS_FOR-SALE'
          | 'MARKET-ITEM_STATUS_STOP-SALE'
        )[];
        /** @example "흰색 티셔츠" */
        textSearch?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DomainListMarketItemsResponse, any>({
        path: `/market-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고 (단건) 생성
     *
     * @tags Markets
     * @name MarketItemsCreate
     * @summary CreateMarketItem
     * @request POST:/market-items
     * @secure
     * @response `204` `void` No Content
     */
    marketItemsCreate: (CreateMarketItemRequest: DomainCreateMarketItemRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/market-items`,
        method: 'POST',
        body: CreateMarketItemRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description ### 채팅방에 필요한 데이터들을 조회합니다. : https://github.com/looko-corp/acloset-api/issues/530 #### 해당 API는 채팅방 리스트를 보여줄 때 사용자의 닉네임, 이미지 또는 상품의 이미지등을 보여주기 위해서 부르는 API 입니다. 샌드버드에서 관리하는 channel_url로 chatroomID를 query filter 하기를 기대하고 있습니다. --- ### QueryParam - chatroomID : 샌드버드 ID를 요청받으면 해당 값을 기준으로 필터링 (group_channel의 channel_url값을 기대) (collectionFormat": "multi") - marketItemID : 중고 ID를 요청받으면 해당 값을 기준으로 필터링 ### Authorization 헤더에 서비스 토큰을 넣어주시면 해당 유저를 기준으로 채팅방리스트를 전부 조회합니다. ### 만약 서비스 토큰이 유효하지 않은 경우 아래와 같은 에러를 내뱉습니다. - ### `[401] {AUTH_UNAUTHORIZED} - 인증에 실패하였습니다.}` Swagger 문서작성 (2022-01-11)
     *
     * @tags Markets
     * @name ChatroomsList
     * @summary ListMarketItemChatrooms
     * @request GET:/market-items/chatrooms
     * @secure
     * @response `200` `DomainListMarketItemChatroomsResponse` 채팅방 리스트 응답 값
     */
    chatroomsList: (
      query?: {
        /**
         * 채팅방 ID (Sendbird 한정 : channel_url)
         * @example ["sendbird_group_channel_25108471_a1bc35f5f0d237207bc1rd343562c878fc2fd426"]
         */
        chatroomID?: string[];
        /**
         * 중고 아이템 ID
         * @example 123883
         */
        marketItemID?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DomainListMarketItemChatroomsResponse, any>({
        path: `/market-items/chatrooms`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고 채팅방 삭제 (marketItemID or chatroomIDs 값중 하나는 필수 값)
     *
     * @tags Markets
     * @name ChatroomsDelete
     * @summary DeleteMarketItemChatrooms
     * @request DELETE:/market-items/chatrooms
     * @secure
     * @response `204` `void` No Content
     */
    chatroomsDelete: (
      DeleteMarketItemChatroomsRequest: DomainDeleteMarketItemChatroomsRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, any>({
        path: `/market-items/chatrooms`,
        method: 'DELETE',
        body: DeleteMarketItemChatroomsRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 구매자의 리뷰 거절
     *
     * @tags Markets
     * @name ClaimPurchaseCreate
     * @summary ClaimPurchase
     * @request POST:/market-items/claim-purchase
     * @secure
     * @response `204` `void` No Content
     */
    claimPurchaseCreate: (ClaimPurchaseRequest: DomainClaimPurchaseRequest, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/market-items/claim-purchase`,
        method: 'POST',
        body: ClaimPurchaseRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 중고 아이템 판매 종료
     *
     * @tags Markets
     * @name CloseCreate
     * @summary CloseMarketItem
     * @request POST:/market-items/close
     * @secure
     * @response `204` `void` No Content
     * @response `400` `ErrorsErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: MARKET_ITEM_UPDATION_NOT_ALLOWED
     * @response `404` `ErrorsErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
     */
    closeCreate: (CloseMarketItemRequest: DomainCloseMarketItemRequest, params: RequestParams = {}) =>
      this.http.request<void, ErrorsErrorResponse>({
        path: `/market-items/close`,
        method: 'POST',
        body: CloseMarketItemRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Markets
     * @name FilterList
     * @summary ListFilterMarketItemCounts
     * @request GET:/market-items/filter
     * @secure
     * @response `200` `DomainListFilterMarketItemCountsResponse` 주간 마켓아이템 갯수
     */
    filterList: (
      query?: {
        /**
         * 포함할 카테고리 ID
         * @example [1,2,3]
         */
        categoryIDs?: number[];
        /**
         * 포함할 컬러 ID
         * @example [1,2,3]
         */
        colorIDs?: number[];
        /** 브랜드는 종류가 너무 많아서 특정 Group by 하면 로드가 부담되어 현재 페이지 브랜드만 Group by */
        currentPageOfficialBrandIDs?: number[];
        /**
         * 최대 할인율
         * @example 50
         */
        discountPriceMax?: number;
        /**
         * 최소 할인율 (최소 할인율 0 이상)
         * @example 10
         */
        discountPriceMin?: number;
        /**
         * 포함할 성별
         * @example ["MARKET-ITEM_GENDERWEAR_MEN"]
         */
        genderWear?: (
          | 'MARKET-ITEM_GENDERWEAR_WOMEN'
          | 'MARKET-ITEM_GENDERWEAR_MEN'
          | 'MARKET-ITEM_GENDERWEAR_GIRL'
          | 'MARKET-ITEM_GENDERWEAR_BOY'
          | 'MARKET-ITEM_GENDERWEAR_UNISEX'
          | 'MARKET-ITEM_GENDERWEAR_KID_UNISEX'
        )[];
        /** 포함할 공식 브랜드 */
        officialBrandIDs?: number[];
        /**
         * 포함할 판매자 ID
         * @example [1,2,3]
         */
        sellerIDs?: number[];
        /** @example "흰색 티셔츠" */
        textSearch?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DomainListFilterMarketItemCountsResponse, any>({
        path: `/market-items/filter`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 프로모션 정보 리스트 조회
     *
     * @tags Markets
     * @name PromotionInfosList
     * @summary ListPromotionInfos 프로모션 정보 리스트 조회
     * @request GET:/market-items/promotion-infos
     * @secure
     * @response `200` `DomainListPromotionInfosResponse` 프로모션 정보 리스트 응답 값
     */
    promotionInfosList: (params: RequestParams = {}) =>
      this.http.request<DomainListPromotionInfosResponse, any>({
        path: `/market-items/promotion-infos`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 조회한 결과로 나온 마켓아이템의 판매자가 내가 차단한 사용자라면, 해당 마켓아이템은 제외합니다. 추가적으로 hasNext 필드를 추가하여, 다음 페이지가 있는지 없는지를 알려줍니다. 최대 150개 까지만 조회할 수 있습니다. 최근 본 마켓아이템 리스트 조회, 작동확인 (없으면 빈 리스트)
     *
     * @tags Markets
     * @name RecentlyViewedList
     * @summary ListRecentlyViewedMarketItems
     * @request GET:/market-items/recently-viewed
     * @secure
     * @response `200` `DomainListRecentlyViewedMarketItemsResponse` 최근 본 마켓아이템 응답값
     */
    recentlyViewedList: (
      query?: {
        /**
         * 최근 본 중고 아이템 목록의 개수
         * @example 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DomainListRecentlyViewedMarketItemsResponse, any>({
        path: `/market-items/recently-viewed`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 추천 정보 리스트 조회
     *
     * @tags Markets
     * @name RecommendationInfosList
     * @summary ListRecommInfos 추천 정보 리스트 조회
     * @request GET:/market-items/recommendation-infos
     * @secure
     * @response `200` `DomainListRecommInfosResponse` 중고 리스트 응답 값
     */
    recommendationInfosList: (params: RequestParams = {}) =>
      this.http.request<DomainListRecommInfosResponse, any>({
        path: `/market-items/recommendation-infos`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Markets
     * @name WeeklyCountList
     * @summary CountWeeklyMarketItem
     * @request GET:/market-items/weekly-count
     * @secure
     * @response `200` `DomainCountWeeklyMarketItemResponse` 주간 마켓아이템 갯수
     */
    weeklyCountList: (params: RequestParams = {}) =>
      this.http.request<DomainCountWeeklyMarketItemResponse, any>({
        path: `/market-items/weekly-count`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고 단건 조회, 작동확인
     *
     * @tags Markets
     * @name MarketItemsDetail
     * @summary GetMarketItem
     * @request GET:/market-items/{marketItemID}
     * @secure
     * @response `200` `DomainGetMarketItemResponse` 중고 단건 응답값
     */
    marketItemsDetail: (marketItemId: number, params: RequestParams = {}) =>
      this.http.request<DomainGetMarketItemResponse, any>({
        path: `/market-items/${marketItemId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고(단건) 갱신
     *
     * @tags Markets
     * @name MarketItemsUpdate
     * @summary UpdateMarketItem
     * @request PUT:/market-items/{marketItemID}
     * @secure
     * @response `204` `void` No Content
     * @response `400` `ErrorsErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: MARKET_ITEM_UPDATION_NOT_ALLOWED
     * @response `404` `ErrorsErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
     */
    marketItemsUpdate: (
      marketItemId: number,
      UpdateMarketItemRequest: DomainUpdateMarketItemRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, ErrorsErrorResponse>({
        path: `/market-items/${marketItemId}`,
        method: 'PUT',
        body: UpdateMarketItemRequest,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description 중고(단건) 삭제
     *
     * @tags Markets
     * @name MarketItemsDelete
     * @summary DeleteMarketItem
     * @request DELETE:/market-items/{marketItemID}
     * @secure
     * @response `204` `void` No Content
     * @response `400` `ErrorsErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: MARKET_ITEM_DELETION_NOT_ALLOWED
     * @response `404` `ErrorsErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
     */
    marketItemsDelete: (marketItemId: number, params: RequestParams = {}) =>
      this.http.request<void, ErrorsErrorResponse>({
        path: `/market-items/${marketItemId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description 중고(단건) 갱신
     *
     * @tags Markets
     * @name MarketItemsPartialUpdate
     * @summary PatchMarketItem
     * @request PATCH:/market-items/{marketItemID}
     * @secure
     * @response `204` `void` No Content
     * @response `400` `ErrorsErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: MARKET_ITEM_UPDATION_NOT_ALLOWED
     * @response `404` `ErrorsErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
     */
    marketItemsPartialUpdate: (
      marketItemId: number,
      PatchMarketItemRequest: DomainPatchMarketItemRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, ErrorsErrorResponse>({
        path: `/market-items/${marketItemId}`,
        method: 'PATCH',
        body: PatchMarketItemRequest,
        secure: true,
        ...params,
      }),

    /**
     * @description 중고 마켓아이템 판매중변경
     *
     * @tags Markets
     * @name AsProcessingPartialUpdate
     * @summary PatchMarketItemAsProcessing
     * @request PATCH:/market-items/{marketItemID}/as-processing
     * @secure
     * @response `204` `void` No Content
     * @response `400` `ErrorsErrorResponse` 마켓 아이템에 진행중인 거래가 있을때 Code: TX_DUPLICATED<br />마켓 아이템이 판매중이 아닐때 Code: MARKET_ITEM_NOT_FOR_SALE
     * @response `404` `ErrorsErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
     */
    asProcessingPartialUpdate: (marketItemId: number, params: RequestParams = {}) =>
      this.http.request<void, ErrorsErrorResponse>({
        path: `/market-items/${marketItemId}/as-processing`,
        method: 'PATCH',
        secure: true,
        ...params,
      }),

    /**
     * @description 중고 마켓아이템 판매중으로 변경
     *
     * @tags Markets
     * @name AsSellingPartialUpdate
     * @summary PatchMarketItemAsSelling
     * @request PATCH:/market-items/{marketItemID}/as-selling
     * @secure
     * @response `204` `void` No Content
     * @response `400` `ErrorsErrorResponse` 마켓 아이템 상태가 Processing가 아닐때 Code: MARKET_ITEM_NOT_PROCESSING
     * @response `404` `ErrorsErrorResponse` 마켓 아이템 미존재시 Code: MARKET_ITEM_NOT_FOUND
     */
    asSellingPartialUpdate: (
      marketItemId: number,
      PatchMarketItemAsSellingRequest: DomainPatchMarketItemAsSellingRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<void, ErrorsErrorResponse>({
        path: `/market-items/${marketItemId}/as-selling`,
        method: 'PATCH',
        body: PatchMarketItemAsSellingRequest,
        secure: true,
        ...params,
      }),

    /**
     * @description 중고 북마크 생성
     *
     * @tags Markets
     * @name BookmarksCreate
     * @summary CreateMarketItemBookmark
     * @request POST:/market-items/{marketItemID}/bookmarks
     * @secure
     * @response `204` `void` No Content
     */
    bookmarksCreate: (marketItemId: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/market-items/${marketItemId}/bookmarks`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description 중고 북마크 삭제
     *
     * @tags Markets
     * @name BookmarksDelete
     * @summary DeleteMarketItemBookmark
     * @request DELETE:/market-items/{marketItemID}/bookmarks
     * @secure
     * @response `204` `void` No Content
     */
    bookmarksDelete: (marketItemId: number, params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/market-items/${marketItemId}/bookmarks`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * @description 판매완료, 판매중지, 거래중의 아이템과 비슷한 아이템을 추천
     *
     * @tags Markets
     * @name CartSimilarItemsDetail
     * @summary 장바구니에서 비슷한 상품 추천
     * @request GET:/market-items/{marketItemID}/cart-similar-items
     * @secure
     * @response `200` `DomainListCartSimilarMarketItemsResponse` 중고 리스트 응답 값
     */
    cartSimilarItemsDetail: (
      marketItemId: number,
      query: {
        /** @example 30 */
        limit: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DomainListCartSimilarMarketItemsResponse, any>({
        path: `/market-items/${marketItemId}/cart-similar-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고 채팅방 생성, mSwagger 문서작성 (2023-01-19)
     *
     * @tags Markets
     * @name ChatroomsCreate
     * @summary CreateMarketItemChatroo
     * @request POST:/market-items/{marketItemID}/chatrooms
     * @secure
     * @response `200` `DomainCreateMarketItemChatroomResponse` 중고 채팅방 생성 응답 값
     */
    chatroomsCreate: (
      marketItemId: number,
      CreateMarketItemChatroomRequest: DomainCreateMarketItemChatroomRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainCreateMarketItemChatroomResponse, any>({
        path: `/market-items/${marketItemId}/chatrooms`,
        method: 'POST',
        body: CreateMarketItemChatroomRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Markets
     * @name EditableDetail
     * @summary GetMarketItemEditable
     * @request GET:/market-items/{marketItemID}/editable
     * @secure
     * @response `200` `DomainGetMarketItemEditableResponse` 삭제 수정 가능 여부 응답값
     */
    editableDetail: (
      marketItemId: string,
      query?: {
        marketItemID?: number;
        /** @example "EDIT,DELETE,CLOSE" */
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DomainGetMarketItemEditableResponse, any>({
        path: `/market-items/${marketItemId}/editable`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고 리뷰 생성
     *
     * @tags Markets
     * @name ReviewsCreate
     * @summary CreateMarketItemReview
     * @request POST:/market-items/{marketItemID}/reviews
     * @secure
     * @response `200` `DomainCreateMarketItemReviewResponse` 중고 리뷰 생성 응답값
     */
    reviewsCreate: (
      marketItemId: number,
      CreateMarketItemReviewRequest: DomainCreateMarketItemReviewRequest,
      params: RequestParams = {},
    ) =>
      this.http.request<DomainCreateMarketItemReviewResponse, any>({
        path: `/market-items/${marketItemId}/reviews`,
        method: 'POST',
        body: CreateMarketItemReviewRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description 중고 리뷰 단건 조회, 작동확인
     *
     * @tags Markets
     * @name ReviewsDetail
     * @summary GetMarketItemReview
     * @request GET:/market-items/{marketItemID}/reviews/{reviewID}
     * @secure
     * @response `200` `DomainGetMarketItemReviewResponse` 중고 리뷰 조회 반환 값
     */
    reviewsDetail: (marketItemId: number, reviewId: number, params: RequestParams = {}) =>
      this.http.request<DomainGetMarketItemReviewResponse, any>({
        path: `/market-items/${marketItemId}/reviews/${reviewId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 비슷한 상품 추천
     *
     * @tags Markets
     * @name SellersOtherItemsDetail
     * @summary ListSellersOtherMarketItems
     * @request GET:/market-items/{marketItemID}/sellers-other-items
     * @secure
     * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
     */
    sellersOtherItemsDetail: (
      marketItemId: number,
      query: {
        /** @example 30 */
        limit: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DomainListMarketItemsResponse, any>({
        path: `/market-items/${marketItemId}/sellers-other-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 비슷한 상품 추천
     *
     * @tags Markets
     * @name SimilarBrandItemsDetail
     * @summary ListSimilarBrandMarketItems
     * @request GET:/market-items/{marketItemID}/similar-brand-items
     * @secure
     * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
     */
    similarBrandItemsDetail: (
      marketItemId: number,
      query: {
        /** @example 30 */
        limit: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DomainListMarketItemsResponse, any>({
        path: `/market-items/${marketItemId}/similar-brand-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 소재 상품 모음전
     *
     * @tags Markets
     * @name SimilarFabricItemsDetail
     * @summary ListSimilarFabricMarketItems
     * @request GET:/market-items/{marketItemID}/similar-fabric-items
     * @secure
     * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
     */
    similarFabricItemsDetail: (
      marketItemId: number,
      query: {
        /** @example 30 */
        limit: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DomainListMarketItemsResponse, any>({
        path: `/market-items/${marketItemId}/similar-fabric-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description 비슷한 상품 추천
     *
     * @tags Markets
     * @name SimilarItemsDetail
     * @summary ListSimilarMarketItems
     * @request GET:/market-items/{marketItemID}/similar-items
     * @secure
     * @response `200` `DomainListMarketItemsResponse` 중고 리스트 응답 값
     */
    similarItemsDetail: (
      marketItemId: number,
      query: {
        /** @example 30 */
        limit: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DomainListMarketItemsResponse, any>({
        path: `/market-items/${marketItemId}/similar-items`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name TransactionsDetail
     * @summary GetTxRecently
     * @request GET:/market-items/{marketItemID}/transactions
     * @secure
     * @response `200` `DomainGetOrderResponse` 거래 상세 조회 응답값
     * @response `404` `ErrorsErrorResponse` 거래가 존재하지 않을 경우 Code: TX_NOT_FOUND
     */
    transactionsDetail: (
      marketItemId: number,
      query?: {
        /** @example 1 */
        buyerID?: number;
        /** @example 1 */
        sellerID?: number;
      },
      params: RequestParams = {},
    ) =>
      this.http.request<DomainGetOrderResponse, ErrorsErrorResponse>({
        path: `/market-items/${marketItemId}/transactions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  sendbird = {
    /**
     * @description Swagger 문서작성 (2022-01-11) ### 특정 유저의 샌드버드 토큰을 조회합니다. : https://github.com/looko-corp/acloset-api/issues/511 --- ### Authorization 헤더에 서비스 토큰을 넣어주시면 샌드버드 토큰을 반환합니다. ### 만약 샌드버드 계정이 없는 경우에 토큰을 요청하면 아래와 같은 에러가 발생합니다. - ### `[404] {SENDBIRD_TOKEN_NOT_FOUND - 토큰을 찾을 수 없습니다.}`
     *
     * @tags Sendbird
     * @name TokenList
     * @summary GetSendbirdToken
     * @request GET:/sendbird/token
     * @secure
     * @response `200` `DomainGetSendbirdTokenResponse` 토큰 요청 응답 값
     */
    tokenList: (params: RequestParams = {}) =>
      this.http.request<DomainGetSendbirdTokenResponse, any>({
        path: `/sendbird/token`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description ### 특정 유저의 샌드버드 토큰을 만듭니다 : https://github.com/looko-corp/acloset-api/issues/522 --- ### Authorization 헤더에 서비스 토큰을 요청하면 만들어 집니다. ### 만약 샌드버드 계정이 이미 있는 경우에는 아래와 같은 에러가 발생합니다. - ### `[409] {SENDBIRD_TOKEN_ALREADY_EXISTS - 이미 토큰이 존재합니다}` Swagger 문서작성 (2022-01-11)
     *
     * @tags Sendbird
     * @name TokenCreate
     * @summary CreateSendbirdToken
     * @request POST:/sendbird/token
     * @secure
     * @response `204` `void` No Content
     */
    tokenCreate: (params: RequestParams = {}) =>
      this.http.request<void, any>({
        path: `/sendbird/token`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * @description Swagger 문서작성 (2022-01-11) ### 특정유저의 샌드버드 채팅에서 안읽은 메세지수 조회 : https://github.com/looko-corp/acloset-api/issues/528 --- ### Authorization 헤더에 서비스 토큰을 요청하면 만들어 집니다. ### 만약 샌드버드 계정이 없는 경우에 토큰을 요청하면 아래와 같은 에러가 발생합니다. - ### `[404] {SENDBIRD_TOKEN_NOT_FOUND - 토큰을 찾을 수 없습니다.}`
     *
     * @tags Sendbird
     * @name UnreadMessageCountList
     * @summary CountSendbirdUnreadMessage
     * @request GET:/sendbird/unread-message-count
     * @secure
     * @response `200` `DomainCountSendbirdUnreadMessageResponse` 안읽은 메세지 개수 응답 값
     */
    unreadMessageCountList: (params: RequestParams = {}) =>
      this.http.request<DomainCountSendbirdUnreadMessageResponse, any>({
        path: `/sendbird/unread-message-count`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
